// en, de, fr, br
import validationMessages from "vee-validate/dist/locale/pt_BR";

export default {
    //"pt-BR": {
    validations: {
        messages: {
            ...validationMessages.messages,
            "email-or-cpf": "O campo {_field_} não é um E-MAIL ou CPF válido",
            cpf: "O campo {_field_} possui um formato inválido",
            cnpj: "O campo {_field_} possui um formato inválido",
            pis: "O campo {_field_} possui um formato inválido",
            "zip-code": "O campo {_field_} possui um formato inválido",
            "full-name": "O campo {_field_} é inválido",
            date: "O campo {_field_} é uma data inválida",
            "date-month-year": "O campo {_field_} é uma data inválida",
            "before-date": "A data informada é maior que a data final",
            "after-date": "A data informada é menor que a data inicial",
            "minority-date": "A idade mínima para cadastro é de 14 anos.",
            required_unless: "O campo {_field_} é obrigatório",
            must_exists_if: "É necessário selecionar ao menos uma opção",
            cns: "O campo {_field_} possui um formato inválido",
            "password-username-checker": "A senha informada não pode ser utilizada.",
            "password-weakness-checker": "A senha informada é muito fraca.",
            "cellphone": "O campo {_field_} possui um formato inválido",
        },
    },
    //Find a better place to allocate this ↓↓↓
    image: {
        change_image: "Mudar imagem",
        send_image: "Enviar imagem"
    },
    files: {
        remove: {
            done: "Arquivo removido com sucesso",
            fail: "Não foi possível excluir o seu arquivo. Por favor tente novamente",
        },
        the_requested_file_could_not_be_found: "Não foi possível encontrar o arquivo solicitado",
    },
    changeable: {
        "indicator-text":
            "Alterações salvas | {count} alteração pendente | {count} alterações pendentes",
    },
    errors: {
        403: "Acesso não permitido",
        404: "Página não encontrada",
        "create-password": "Crie uma senha!",
        account_recover: {
            "not-found": "Dados inválidos, tente novamente.",
        },
        link_account: {
            "already-existent":
                "Já existe um cadastro com este documento. Se não lembrar o acesso, recupere sua conta na tela de login.",
        },
        communication: {
            "not-sent":
                "Não foi possível registrar o seu contato. Por favor tente novamente",
        },
        title: {
            danger: "Erro",
            warning: "Aviso",
            info: "Informação",
        },
        "default-title": "Erro",
        account: {
            error: "Falha ao enviar email de reset, tente novamente.",
            "social-media-account":
                "Sua conta foi criada a partir de uma rede social. Para recuperar sua conta, entre em contato com a empresa responsável.",
            "not-found":
                "Conta não encontrada, verifique se o CPF foi digitado corretamente.",
            "password-reset-throttled":
                "Um e-mail de reset foi enviado há poucos instantes, aguarde 10 minutos para tentar novamente.",
        },
        registration: {
            message:
                "Não foi possível completar o seu cadastro. Por favor tente novamente.",
            message_alt: "Não foi possível realizar o cadastro. Por favor tente novamente",
            "account-existent":
                "Você já possuí uma conta! Faça o login para continuar.",
            cpf_already_registered_in_our_database: "CPF já cadastrado em nossa base!",
        },
        curriculum: {
            "not-found": "Currículo não encontrado",
            invalid_zip_format:  "O campo cep possui um formato inválido",
            invalid_bank_name_list:
                "Selecione um banco da lista permitida pelo processo seletivo.",
        },
        vacancy: {
            "not-found": "Vaga não encontrada",
            "not_found_description": "A vaga que você está procurando não foi localizada.<br/>Clique no botão abaixo para conferir outras oportunidades disponíveis.",
            "expired": "Vaga indisponível",
            "expired_description": "Esta vaga não está mais disponível para candidaturas.<br/>Clique no botão abaixo para ver outras oportunidades."
        },
        enroll: {
            "not-found": "Vaga não encontrada",
            "already-applied": "Você já candidatou-se a esta vaga!",
            "already-applied-title": "Já se candidatou!",
            forbidden: "Você não tem permissão para candidatar-se a esta vaga",
            "unfilled-fields": "Existem alguns campos necessários para conclusão da candidatura. Por favor, preencha os campos abaixo para prosseguir:",
            "does-not-attend": "Seu currículo não atende os requisitos mínimos abaixo:",
            "maintain-updated": "Mantenha sempre seu currículo atualizado para novas oportunidades.",
            pcd: "PCD",
            education: "Formação Acadêmica",
            languages: "Idiomas",
            computing: "Computação",
            "exclusive-selective-process": "Este processo seletivo exige exclusividade e o candidato está participando de outro processo",
            "application-closed": "Obrigado pelo seu interesse! Infelizmente, esta oportunidade não está mais aceitando candidaturas."
        },
        file: {
            file_upload_failed: "O upload do arquivo não foi realizado com sucesso!",
        }
    },
    responses: {
        communication: {
            success:
                "Recebemos o seu pedido e entraremos em contato o quanto antes para resolução",
        },
        feedback: {
            success: "Agradecemos pela sua ajuda!",
        },
    },
    ocr: {
        error_title: "Atenção!",
        error_description:
            "Não conseguimos identificar algumas informações do documento:",
        error_validate: "Por favor verifique:",
        error_validate_item_1: "A imagem do documento anexado",
        error_validate_item_2: " O preenchimento dos campos acima",
        await_title: "Aguarde",
        await_description:
            "Aguarde, estamos validando as informações do documento.",
    },
    parsing: {
        send_another_file: "Enviar outro arquivo",
        check_the_info:
            "Confira se os campos foram preenchidos corretamente e complete o que precisar",
        ready: "Prontinho!",
        read_file: "Lendo seu currículo...",
        start_fill: "Iniciar Preenchimento",
        search_file: "Buscar Arquivo",
        send_file:
            "Se preferir, envie seu currículo (PDF ou Word) para criar seu perfil como num passe de mágica",
    },
    common: {
        understood: "Entendi",
        wait: "Aguarde!",
        saving_info: "Salvando informações...",
        saving_changes: "Salvando alterações...",
        dependent: "Dependente",
        attention: "Atenção",
        success: "Sucesso",
        saved_successfully: "Salvo com Sucesso",
        error: "Erro",
        loading: "Carregando",
        send: "Enviar",
        my_painel: "Meu Painel",
        complementary_data: "Dados Complementares",
        admission_data: "Dados Admissionais",
        apply: "Aplicar",
        yes: "Sim",
        create_new_section: "Criar nova seção",
        no: "Não",
        male: "Masculino",
        female: "Feminino",
        required: "Campo obrigatório",
        back_to_home: "Voltar ao início",
        edit: "Editar",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
        upload_photo: "Carregar Foto",
        advance: "Avançar",
        "no-results-found": "Nenhum resultado encontrado",
        "search-new-term": ", digite uma nova busca.",
        see: "Ver",
        search: "Buscar",
        or: "ou",
        and: "e",
        description: "Descrição",
        progress: "Progresso",
        link_with_sj: "Vincular com SelectyJobs",
        link_with_facebook: "Vincular com Facebook",
        link_with_linkedin: "Vincular com LinkedIn",
        link_with_google: "Vincular com Google",
        join: "Entrar",
        join_with_sj: "Entrar com SelectyJobs",
        join_with_facebook: "Entrar com Facebook",
        join_with_linkedin: "Entrar com LinkedIn",
        join_with_google: "Entrar com Google",
        join_with_ecidadao: "Entrar com E-Cidadão",
        join_with_ad: "Entrar com Active Directory",
        please_type_captcha_correctly:
            "Por favor, preencha o captcha corretamente.",
        to_continue_auth: "Para continuar, selecione uma das opções abaixo",
        register: "Cadastrar-se",
        create_account: "Criar Conta",
        create_profile: "Criar perfil",
        profile: "Perfil",
        lets_begin: "Vamos começar!",
        lets_begin_subtitle: "Insira as informações básicas abaixo",
        jobs: "Vagas",
        show: "Mostrar",
        hide: "Ocultar",
        hello: "Olá",
        complete_curriculum: "Completar meu currículo",
        follow_process: "Acompanhar processo seletivo",
        curriculum: "Currículo",
        admissional: "Admissional",
        logout: "Sair",
        exit_warning: "Existem campos obrigatórios não preenchidos, realmente deseja sair?",
        begin: "Início",
        vacancy: "Vagas",
        messages: "Mensagens",
        account: "Conta",
        email: "E-mail",
        password: "Senha",
        change: "Mudar",
        close: "Fechar",
        in: "em",
        click: "Clique aqui",
        to_add: "para adicionar",
        captcha_error: "Por favor, preencha o captcha corretamente.",
        course_not_found: "Não foi possível encontrar o curso",
        institution_not_found: "Não foi possível encontrar a instituição",
        document_not_found: "Não foi possível encontrar o documento",
        training_not_found: "Não foi possível encontrar o treinamento",
        occupation_not_found: "Não foi possível encontrar o cargo",
        computing_knowledge_not_found: "Não foi possível encontrar o conhecimento",
        please_insert_document: "Por favor, informe seu CPF.",
        why_we_need_that: "Por que estamos pedindo essa informação?",
        creation_garantee:
            "Queremos garantir que você terá um cadastro único e com identificação segura. Por isso, o CPF será sua chave principal de acesso.",
        validate_informations: "Validar informações",
        present: "até o momento",
        create_professional_profile:
            "Cadastre seu perfil profissional agora mesmo!",
        start_end: "Inicio/Fim",
        period: "Período",
        from_selecty_platform: "da plataforma Selecty",
        and_the: "e as",
        from_company: "da empresa {company}",
        visit: "Visitar",
        for_companies: "Para empresas",
        notification_updated_successfully: "Notificação atualizada com sucesso",
        failed_to_update_data: "Falha ao atualizar os dados.",
        user_successfully_linked:"Usuário vinculado com sucesso!",
        successfully_completed: "Finalizado com sucesso",
        updated_successfully: "Atualizado com sucesso",
        status_updated: "Status atualizado",
        status_not_updated: "Status não atualizado",
        email_updated_successfully: "Email atualizado com sucesso",
        password_changed_successfully: "Senha alterada com sucesso",
        avatar_successfully_updated: "Avatar alterado com sucesso",
        your_request_was_successfully_completed: "Sua requisição foi realizada com sucesso",
        invalid_data: "Dados inválidos!",
        incorrect_data: "Dados incorretos",
        invalid_captcha: "Captcha inválido!",
        successfully_saved: "Salvo com sucesso",
        data_save_error: "Erro ao salvar os dados",
        physical: "Física",
        digital: "Digital",
        field_mismatch:  "O campo está divergente do arquivo enviado",
        application: "Candidatura",
        results: "Resultado",
        answer: "Responder",
        perform_assessment: "Realizar avaliação",
        download_file: "Baixar arquivo",
        accepted: "Aceito",
    },
    redirecting: {
        redirecting: "Redirecionando",
        please_wait: "Por favor aguarde...",
        access_forbiden: "Acesso não autorizado",
        enroll_portal: "Você será redirecionado para o portal",
    },
    reset_password: {
        passwords: {
            sent: "E-mail enviado com sucesso.",
            user: "E-mail enviado com sucesso.",
            token: "Token Inválido. Por favor faça o processo novamente.",
            reset: "Sua senha foi alterada com êxito.",
        },
    },
    password_level: {
        very_week: "Muito fraca",
        week: "Fraca",
        regular: "Regular",
        strong: "Muito Forte",
    },
    forms: {
        fields: {
            upload: "Anexar Arquivo",
            remove_file: "Remover arquivo",
            allowed_extensions: "Extensões permitidas",
            default_error:
                "Não foi possível realizar o envio do arquivo. Por favor tente novamente",
        },
    },
    company: {
        config: {
            logo_position: {
                label: "",
                placeholder: "",
                description: "",
            },
        },
    },
    customize: {
        main_title: "Customizar",
        subtitle:
            "Escolha a cor do tema, adicione áreas de conteúdo, fotos e mais.",
        color_theme: "Cor do tema",
        color_theme_description: "Afeta botões e elementos interativos.",
        logo_position: "Posição da logo",
        logo_position_description:
            "Selecione a melhor posição para sua logo no portal.",
        sections: "Áreas de conteúdo",
        sections_description:
            "Arraste a seção para alterar a posição de exibição.",

        type: {
            placeholder: "Selecione",
        },
        base_theme: {
            label: "Tema Principal",
            placeholder: "Selecione o tema principal",
            description: "",
        },
        "primary-color": {
            label: "Cor primária",
            placeholder: "Selecione a cor primária",
            description: "",
        },
        title: {
            label: "Título",
            placeholder: "Digite o Título",
            description: "",
        },
        banner: {
            add_banner: "Adicionar Banner",
            remove_banner: "Remover Banner",
            more_details: "Mais detalhes",
            redirect_url: {
                label: "Link de redirecionamento",
                placeholder: "",
                description: "",
            },
            banner_specifications: {
                recommended_dimensions: "Dimensões recomendadas:",
                maximum_file_size: "Tamanho máximo do arquivo:",
                supported_files: "Arquivos suportados:",
                dimensions: "1920 x 560px",
                size: "10mb",
                formats: "JPG ou PNG"
            },
        },
    },
    passwords: {
        cpf: {
            label: "CPF",
            placeholder: "Insira seu CPF",
            description: "",
        },
        cellphone: {
            label: "Celular",
            placeholder: "Insira o número de celular cadastrado",
            description: "",
        },
        birth_date: {
            label: "Data de Nascimento",
            placeholder: "Insira sua data de nascimento",
            description: "",
        },
        primary_email: {
            label: "Email",
            placeholder: "Insira seu email cadastrado",
            description: "",
        },
        mother_name: {
            label: "Nome da mãe",
            placeholder: "Insira o nome da mãe",
            description: "",
        },
    },
    user: {
        login: {
            email: {
                label: "E-mail",
                placeholder: "",
                description: "",
            },
            is_foreigner: {
                label: "Sou estrangeiro",
                placeholder: "",
                description: "",
            },
            login: {
                label: "CPF",
                placeholder: "",
                description: "",
            },
            password: {
                label: "Senha",
                placeholder: "",
                description: "",
            },
            submit: "Entrar",
            linked: "Entrar com linkedin",
            sj: "Entrar com SelectyJobs",
            joinMessage: "Entre para continuar",
            joinSjMessage: "Entre na sua conta SelectyJobs para continuar",
            needAccount: "Não é cadastrado",
            create_account: "Crie uma conta",
            forgotPassword: "Esqueci minha senha",
            invalidEmailOrPassword: "E-mail e/ou senha inválido(s).",
            forgotUsername: "Esqueceu seus dados de acesso?",
        },
        forgot: {
            login: {
                label: "CPF",
                placeholder: "Digite seu CPF",
                description: "",
            },
            nextStep: "Próximo",
            title: "Esqueceu a senha?",
            info: "Sem problemas. Vamos te enviar um e-mail com instruções para criar uma nova senha.",
            submit: "Criar nova senha",
            return_to: "Voltar ao login",
            email_sent: "E-mail enviado!",
            invalid_email: "Email inválido!",
            email_instructions:
                "Enviamos um e-mail para {email} com instruções para criar uma nova senha.",
            email_spam_instructions:
                "Se o e-mail estiver demorando para chegar verifique sua caixa de spam.",
            minimal_recovery_instructions:
                "Caso exista currículo cadastrado com os dados informados, será encaminhado um e-mail para que possa realizar a troca da senha.",
            no_longer_email_access: "Não tenho mais acesso a este e-mail",
            recover_account: "Recuperar conta",
            recover_account_failure: "Falha ao recuperar conta.",
            contact_to:
                "Falha ao validar dados da conta. Para recuperar sua conta, entre em contato com a {company_name}.",
            social_media_account:
                "Sua conta foi criada a partir de uma rede social, faça o login por esta rede social ou recupere a conta abaixo:",
            atention: "Atenção!",
        },
        forgotAccount: {
            title: "Esqueceu seus dados de acesso?",
            info: "Sem problemas! Vamos validar algumas informações para recuperar sua conta.",
            next: "Próximo",
            validate_data: "Validar dados",
        },
        confirmAccountData: {
            title: "Encontramos sua conta!",
            info: "Para sua segurança, vamos confirmar algumas informações antes de recuperar sua conta.",
            cellphone:
                "Confirme abaixo o número do celular cadastrado em sua conta:",
            birth_date: "Confirme abaixo sua data de nascimento:",
            email: "Confirme abaixo o seu e-mail cadastrado em sua conta:",
            email_secure:
                "Qual era o e-mail cadastrado na sua conta? Informe o endereço completo. Dica: {email}",
        },
        reset: {
            title: "Crie uma nova senha",
            info: "Quase lá! Agora basta informar uma nova senha.",
            submit: "Alterar minha senha",
            return_to: "Voltar ao login",
        },
        reseted_password_success: {
            title: "Sucesso!",
            info: "Sua senha foi alterada com êxito.",
        },
        reseted_password_error: {
            title: "Ops!",
            info: "Houve um erro ao tentar alterar sua senha, tente novamente.",
        },
        reset_email: {
            title: "Cadastre um novo e-mail",
            info: "Quase lá! Agora basta cadastrar um novo e-mail para enviar o reset de senha.",
            submit: "Alterar e-mail",
            return_to: "Voltar ao login",
        },
    },
    curriculum: {
        title: "Currículo",
        sections: {
            personal: {
                title: "Dados pessoais",
                address: "Dados de Endereço",
                contacts: "Dados de Contato",
                required_contacts: "Insira ao menos um telefone para contato.",
                diversity: "Diversidade e Inclusão",
                diversity_subtitle:
                    "Nós valorizamos a diversidade no ambiente de trabalho, por isso você tem liberdade para fornecer as informações abaixo:",
                extra: "Campos adicionais",
                cnh: "Carteira Nacional de Habilitação",
                login: "Seu login",
                bnt_ready: "Tudo pronto",
                confirm: "Confirmar",
                extra_by_company: "Campos Extras {company}",
            },
            parsing: {
                title: "Leitor automático de CV",
                btn_upload_curriculum: "Preencha pra mim - Importar Currículo",
            },
            professional: {
                title: "Dados profissionais",
                experiences: "Suas experiências",
                objectives: "Objetivos",
                experience: "Jornada Profissional",
                add_experience: "Adicione suas experiências profissionais",
            },
            education: {
                title: "Educação",
                academic: "Sua Escolaridade",
                training: "Treinamento Complementar",
                languages: "Idiomas",
                computing: "Conhecimento em Informática",
            },
            dependents: {
                title: "Dependentes",
            },
            other_information: {
                title: "Outras informações",
            },
            additional: {
                title: "Informações adicionais",
            },
            presentation: {
                title: "Apresentação",
            },
        },
        actions: {
            professional: {
                add_experience: "Adicionar Experiência",
            },
            education: {
                add_academic: "Adicionar Escolaridade",
                add_training: "Adicionar curso ou treinamento",
                add_language: "Adicionar Idioma",
            },
            dependents: {
                add_dependent: "Adicionar dependente",
            },
            transports: {
                add_transports: "Adicionar transporte",
            },
        },
        texts: {
            professional: {
                activities: "Atividades",
            },
            education: {
                academic: {
                    time: {
                        morning: "Manhã",
                        afternoon: "Tarde",
                        night: "Noite",
                    },
                    period: {
                        period: "{n}º Período",
                    },
                    situation: {
                        studying: "Cursando",
                        completed: "Concluído",
                        stopped: "Interrompido",
                    },
                },
                none: "Nenhum",
                basic: "Básico",
                intermediate: "Intermediário",
                advanced: "Avançado",
                fluent: "Fluente",
            },
            dependents: {
                tokens: {
                    a: "Filho(a) Válido",
                    b: "Filho incapacitado para trabalhar",
                    c: "Cônjuge",
                    d: "Pai",
                    e: "Mãe",
                    f: "Sogro(a)",
                    g: "Outros",
                    h: "Avô(ó)",
                    i: "Companheiro(a)",
                    j: "Enteado(a)",
                    k: "Excluído",
                    l: "Ex-cônjuge",
                    m: "Irmã(o) Válido",
                    n: "Irmã(o) incapacitada(o) para trabalhar",
                    o: "Ex-companheiro(a)",
                    p: "Ex-sogro(a)",
                    q: "Neto(a)",
                    r: "Ex-enteado(a)",
                },
            },
            personal: {
                pcd: {
                    not_informed: "Não informado",
                    none: "Nenhuma",
                    physical: "Física",
                    visual: "Visual",
                    auditive: "Auditiva",
                    intelectual: "Intelectual",
                    psicosocial: "Psicossocial",
                    autism: "Autismo",
                    multiple: "Múltiplas",
                    rehabilitated: "Reabilitado",
                },
                phone_with_areacode: "Informe o número de telefone com DDD"
            },
        },
        sensitive: {
            login_username: {
                label: "E-mail ou CPF",
                placeholder: "",
                description: "",
            },
            new_primary_email: {
                label: "Novo Email",
                placeholder: "Insira um novo email",
                description: "",
            },
            new_primary_email_confirmation: {
                label: "Confirmação de Email",
                placeholder: "Confirme o seu novo email",
                description: "",
            },
            password: {
                label: "Senha",
                placeholder: "Digite sua senha",
                description: "",
            },
            password_confirmation: {
                label: "Confirmação de senha",
                placeholder: "Confirme a senha digitada",
                description: "",
            },
            new_password: {
                label: "Nova Senha",
                placeholder: "Crie uma nova senha",
                description: "",
            },
            new_password_confirmation: {
                label: "Confirmação de Nova Senha",
                placeholder: "Confirme sua nova senha",
                description: "",
            },
        },
        personal: {
            is_foreigner: {
                label: "Sou Estrangeiro",
                placeholder: "",
                description: "",
            },
            origin_country: {
                label: "País de Origem",
                placeholder: "",
                description: "",
            },
            document_type_id: {
                label: "Documento de Identificação",
                placeholder: "",
                description: "",
            },
            document_number: {
                label: "Número do Documento",
                placeholder: "",
                description: "",
            },
            primary_email: {
                label: "E-mail",
                placeholder: "Informe seu e-mail",
                description: "",
            },
            primary_email_confirmation: {
                label: "Confirmação de e-mail",
                placeholder: "Confirme o seu e-mail",
                description: "",
            },
            name: {
                label: "Nome completo",
                placeholder: "Informe seu nome completo",
                description: "",
            },
            assumed_name: {
                label: "Nome Social",
                placeholder: "",
                description: "",
            },
            photo3x4_file_id: {
                label: "Foto 3 x 4",
                placeholder: "",
                description: "",
            },
            cpf: {
                label: "CPF",
                placeholder: "Informe seu CPF",
                description: "",
            },
            gender: {
                label: "Gênero",
                placeholder: "Sexo",
                description: "Esta informação é obrigatória para o E-social.",
            },
            birth_date: {
                label: "Data de Nascimento",
                placeholder: "dd/mm/aaaa",
                description: "",
            },
            cellphone: {
                label: "Celular (com WhatsApp)",
                placeholder: "(00) 00000-0000",
                description: "",
            },
            home_phone: {
                label: "Telefone Residencial",
                placeholder: "Digite o seu telefone residencial",
                description: "",
            },
            special_needs: {
                label: "Se enquadra como PCD?",
                placeholder: "Selecione",
                description: "",
            },
            special_needs_details: {
                label: "Especifique",
                placeholder: "Selecione",
                description: "Descrição PCD",
            },
            special_needs_file: {
                label: "Anexar Laudo PCD",
                description: "Anexar Laudo/Certificado de Reabilitação",
                placeholder: "Anexo Laudo",
            },
            rg: {
                label: "RG",
                placeholder: "RG",
                description: "",
            },
            state_rg: {
                label: "Estado Emissor RG",
                placeholder: "Estado Emissor RG",
                description: "",
            },
            organ_rg: {
                label: "Órgão Emissor RG",
                placeholder: "Órgão Emissor RG",
                description: "",
            },
            civil_status: {
                label: "Estado Civil",
                placeholder: "Estado Civil",
                description: "Esta informação é obrigatória para o E-social.",
            },
            cnh_type: {
                label: "Tipo de CNH",
                placeholder: "Tipo de CNH",
                description: "",
            },
            children: {
                label: "Quantidade de filhos",
                placeholder: "Quantidade de filhos",
                description: "",
            },
            children_info: {
                label: "Informações extras sobre seus filhos",
                placeholder: "",
                description: "",
            },

            cellphone: {
                label: "Celular (com WhatsApp)",
                placeholder: "(00) 00000-0000",
                description: "",
            },
            home_phone: {
                label: "Telefone residencial",
                placeholder: "Telefone residencial",
                description: "",
            },
            business_phone: {
                label: "Telefone comercial",
                placeholder: "Telefone comercial",
                description: "",
            },
            message_with: {
                label: "Contato para recado",
                placeholder: "Contato para recado",
                description: "",
            },
            secondary_email: {
                label: "E-mail secundário",
                placeholder: "E-mail secundário",
                description: "",
            },
            site: {
                label: "Site / Linkedin",
                placeholder: "Site / Linkedin",
                description: "",
            },
            avatar: {
                label: "Foto de perfil",
                placeholder: "",
                description: "",
            },
            cv_external: {
                label: "Anexar Currículo",
                placeholder: "",
                description: "",
            },
            cpf_file_id: {
                label: "Anexar CPF",
                placeholder: "",
                description: "",
            },
            city_rg: {
                label: "Cidade emissora RG",
                placeholder: "",
                description: "",
            },
            date_of_issue_rg: {
                label: "Data de emissão RG",
                placeholder: "",
                description: "",
            },
            rg_file_id: {
                label: "Anexar RG (frente)",
                placeholder: "",
                description: "",
            },
            rg_file2_id: {
                label: "Anexar RG (verso)",
                placeholder: "",
                description: "",
            },
            birth_file_id: {
                label: "Anexar Certidão de Nascimento/Casamento/União Estável/Averbação",
                placeholder: "",
                description: "",
            },
            nationality: {
                label: "Nacionalidade",
                placeholder: "",
                description: "",
            },
            born_state: {
                label: "Estado de Nascimento",
                placeholder: "",
                description: "",
            },
            born_city: {
                label: "Cidade de Nascimento",
                placeholder: "",
                description: "",
            },
            mother_name: {
                label: "Nome da Mãe",
                placeholder: "",
                description: "",
            },
            mother_cpf: {
                label: "Cpf da Mãe",
                placeholder: "",
                description: "",
            },
            father_name: {
                label: "Nome do Pai",
                placeholder: "",
                description: "",
            },
            father_cpf: {
                label: "Cpf do Pai",
                placeholder: "",
                description: "",
            },
            racial: {
                label: "Raça / Cor",
                placeholder: "",
                description: "",
            },
            national_health_service_number: {
                label: "Número do Cartão SUS",
                placeholder: "",
                description: "",
            },
            national_health_service_number_file_id: {
                label: "Anexar Cartão SUS",
                placeholder: "",
                description: "",
            },
            professional_number: {
                label: "Número do Registro Profissional (Ex: CRM, CRP)",
                placeholder: "",
                description: "",
            },
            professional_file_id: {
                label: "Anexar Registro Profissional",
                placeholder: "",
                description: "",
            },
            mother_name_not_declared_in_the_document:
                "Nome da mãe não declarado no documento",
            father_name_not_declared_in_the_document:
                "Nome do pai não declarado no documento",
            has_cni:{
                label: "Já possui o novo Documento Nacional de Identidade (CNI)?",
                description: "Carteira Nacional de Identidade. Novo documento que está substituindo o RG",
                help: '<img src="/images/example-images/cni-exemplo.png" width="426" height="240" alt="Exemplo de CNI">',

            }
        },
        address: {
            country: {
                label: "País",
                placeholder: "Selecione o País",
                description: "",
            },
            zip_code: {
                label: "CEP",
                placeholder: "Digite seu CEP",
                description: "",
            },
            street_type: {
                label: "Tipo do Logradouro",
                placeholder: "Tipo do Logradouro",
                description: "",
            },
            street: {
                label: "Logradouro",
                placeholder: "Logradouro",
                description: "",
            },
            number: {
                label: "Número do Endereço",
                placeholder: "Número",
                description: "",
            },
            complement: {
                label: "Complemento do Endereço",
                placeholder: "Complemento",
                description: "",
            },
            district: {
                label: "Bairro",
                placeholder: "Bairro",
                description: "",
            },
            state: {
                label: "Estado",
                placeholder: "Selecione um estado",
                description: "",
            },
            city: {
                label: "Cidade",
                placeholder: "Selecione uma cidade",
                description: "",
            },
            address_file_id: {
                label: "Comprovante de Residência",
                placeholder: "",
                description: "",
            },
        },
        diversity: {
            racial: {
                label: "Étnico-racial",
                description: "Esta informação é obrigatória para o E-social.",
                placeholder: "",
            },
            assumed_name: {
                label: "Nome Social",
                description: "Nome pelo qual você se identifica e é reconhecido(a) socialmente.",
                placeholder: "",
            },
            gender_identity: {
                label: "Identidade de Gênero",
                description: "",
                placeholder: "",
            },
            gender_orientation: {
                label: "Orientação Sexual",
                description: "",
                placeholder: "",
            },
        },
        passport: {
            passport_number: {
                label: "Número de pasaporte",
                description: "",
                placeholder: "",
            },
            passport_country: {
                label: "País de Origem do passaporte",
                description: "",
                placeholder: "",
            },
            passport_date_emission: {
                label: "Passaporte Data Emissão",
                description: "",
                placeholder: "",
            },
            passport_date_validity: {
                label: "Passaporte Data Validade",
                description: "",
                placeholder: "",
            },
        },
        professional: {
            intended_occupation: {
                label: "Cargos Pretendidos",
                placeholder: "",
                description: "(máx 3 cargos)",
            },
            interest_levels: {
                label: "Nível de Interesse",
                placeholder: "",
                description: "(máx 3 interesses)",
            },
            interest_areas: {
                label: "Área de Interesse",
                placeholder: "",
                description: "(máx 3 áreas de interesse)",
            },
            salary_intended: {
                label: "Pretensão salarial",
                placeholder: "Pretensão salarial",
                description: "",
            },
            available_trip: {
                label: "Possui disponibilidade para viajar?",
                placeholder: "",
                description: "",
            },
            has_professional_history: {
                label: "Possui experiência profissional?",
                placeholder: "",
                description: "",
            },
            has_not_professional_history: {
                label: "Não possuo experiência",
                placeholder: "",
                description: "",
            },

            experiences: {
                company_id: {
                    label: "Empresa",
                    placeholder: "Empresa",
                    description: "",
                },
                company_name: {
                    label: "Empresa",
                    placeholder: "Empresa",
                    description: "",
                },
                occupation_id: {
                    label: "Cargo",
                    placeholder: "Cargo",
                    description: "",
                },
                start: {
                    label: "Início",
                    placeholder: "dd/mm/aaaa",
                    description: "",
                },
                finish: {
                    label: "Término",
                    placeholder: "dd/mm/aaaa",
                    description: "",
                },
                last_salary: {
                    label: "Último Salário",
                    placeholder: "Último Salário",
                    description: "",
                },
                current_job: {
                    label: "Emprego Atual",
                    placeholder: "Emprego Atual",
                    description: "",
                },
                acting_area: {
                    label: "Segmento",
                    placeholder: "Segmento",
                    description: "",
                },
                company_size: {
                    label: "Porte da empresa",
                    placeholder: "Porte da empresa",
                    description: "",
                },
                activities: {
                    label: "Atividades Realizadas",
                    placeholder: "Atividades Realizadas",
                    description: "",
                },
            },
        },
        education: {
            schooling_level: {
                label: "Nível Educacional",
                description: "",
                placeholder: "Selecione o nível",
            },
            school_file_id: {
                label: "Anexar Certidão de Escolaridade",
                description: "",
                placeholder: "",
            },
            school_records_file1_id: {
                label: "Anexar Histórico Escolar (Frente)",
                description: "",
                placeholder: "",
            },
            school_records_file2_id: {
                label: "Anexar Histórico Escolar (Verso)",
                description: "",
                placeholder: "",
            },
            has_schooling_level: {
                label: "Você possui escolaridade?",
                placeholder: "",
                description: "",
            },
            has_not_academic_formation: {
                label: "Não possuo escolaridade",
                placeholder: "",
                description: "",
            },
            has_computer_knowledge: {
                label: "Possui conhecimentos em informática?",
                placeholder: "",
                description: "",
            },
            has_languages: {
                label: "Possui conhecimentos em outros idiomas?",
                placeholder: "",
                description: "",
            },
            has_additional_training: {
                label: "Possui cursos ou treinamentos complementares?",
                placeholder: "",
                description: "",
            },
            academic: {
                education_level_id: {
                    label: "Nível Educacional",
                    description: "",
                    placeholder: "Selecione o nível",
                },
                course_id: {
                    label: "Curso",
                    description: "",
                    placeholder: "",
                },
                period: {
                    label: "Período",
                    description: "",
                    placeholder: "",
                },
                time: {
                    label: "Horário",
                    description: "",
                    placeholder: "",
                },
                institution: {
                    label: "Instituição",
                    description: "",
                    placeholder: "Instituição",
                },
                status: {
                    label: "Situação",
                    description: "",
                    placeholder: "Selecione a situação",
                },
                start_date: {
                    label: "Data de início",
                    placeholder: "",
                    description: "",
                },
                conclusion_date: {
                    label: "Data de término",
                    placeholder: "",
                    description: "",
                },
            },
            training: {
                additional_training_id: {
                    label: "Treinamento",
                    placeholder: "Treinamento",
                    description: "",
                },
                name: {
                    label: "Nome do curso ou treinamento",
                    placeholder: "Nome do curso ou treinamento",
                    description: "",
                },
                description: {
                    label: "Descrição dos conhecimentos adquiridos",
                    placeholder: "Descrição dos conhecimentos adquiridos",
                    description: "",
                },
                institution: {
                    label: "Instituição",
                    placeholder: "Instituição",
                    description: "",
                },
                status: {
                    label: "Situação",
                    placeholder: "Situação",
                    description: "",
                },
                start_date: {
                    label: "Período (início)",
                    placeholder: "Período (início)",
                    description: "",
                },
                finish_date: {
                    label: "Período (término)",
                    placeholder: "Período (término)",
                    description: "",
                },
            },
            languages: {
                language_id: {
                    label: "Idioma",
                    placeholder: "Idioma",
                    description: "",
                },
                speaking: {
                    label: "Fala",
                    placeholder: "Fala",
                    description: "",
                },
                writing: {
                    label: "Escrita",
                    placeholder: "Escrita",
                    description: "",
                },
                understanding: {
                    label: "Compreensão",
                    placeholder: "Compreensão",
                    description: "",
                },
                reading: {
                    label: "Leitura",
                    placeholder: "Leitura",
                    description: "",
                },
            },
        },

        computing: {
            title: "Informática",
            label: "",
            basic: {
                label: "Básico",
                placeholder: "Básico",
                description: "",
            },
            intermediate: {
                label: "Intermediário",
                placeholder: "Intermediário",
                description: "",
            },
            advanced: {
                label: "Avançado",
                placeholder: "Avançado",
                description: "",
            },
        },
        additional: {
            abroad_experience: {
                label: "Experiência no exterior",
                placeholder: "Experiência no exterior",
                description: "",
            },
            has_abroad_experience: {
                label: "Possui experiência no exterior",
                placeholder: "Possui experiência no exterior",
                description: "",
            },
            description: {
                label: "Descrição",
                placeholder: "Descrição",
                description: "",
            },
            complementary_activities: {
                label: "Atividades complementares",
                placeholder: "Atividades complementares",
                description: "",
            },
            sports: {
                label: "Esportes",
                placeholder: "Esportes",
                description: "",
            },
            hobby: {
                label: "Hobbies",
                placeholder: "Hobbies",
                description: "",
            },
            music: {
                label: "Música",
                placeholder: "Música",
                description: "",
            },
            passions: {
                label: "Paixões",
                placeholder: "Paixões",
                description: "",
            },
            books: {
                label: "Livros",
                placeholder: "Livros",
                description: "",
            },
            social_work: {
                label: "Trabalhos sociais",
                placeholder: "Trabalhos sociais",
                description: "",
            },
            extra_informations: {
                label: "Informações adicionais",
                placeholder: "Informações adicionais",
                description: "",
            },
            cover_letter: {
                label: "Carta de apresentação",
                placeholder: "Carta de apresentação",
                description: "",
            },
        },
        ctps: {
            has_ctps: {
                label: "Possui Carteira de Trabalho?",
                placeholder: "",
                description: "",
            },
            is_first_job: {
                label: "Será seu primeiro emprego formal?",
                placeholder: "",
                description: "",
            },
            ctps_type: {
                label: "Tipo de Carteira de Trabalho?",
                placeholder: "",
                description: "",
            },
            ctps_number: {
                label: "CTPS Número",
                placeholder: "",
                description: "",
            },
            ctps_serial: {
                label: "CTPS Série",
                placeholder: "",
                description: "",
            },
            ctps_state: {
                label: "CTPS Estado",
                placeholder: "",
                description: "",
            },
            ctps_city: {
                label: "CTPS Cidade",
                placeholder: "",
                description: "",
            },
            ctps_date: {
                label: "CTPS Data Emissão",
                placeholder: "",
                description: "",
            },
            ctps_file_id: {
                label: "Anexar CTPS (Frente)",
                placeholder: "",
                description: "",
            },
            ctps_file2_id: {
                label: "Anexar CTPS (Verso)",
                placeholder: "",
                description: "",
            },
            ctps_file3_id: {
                label: "Anexar Último Registro CTPS",
                placeholder: "",
                description: "",
            },
            has_pis: {
                label: "Possui PIS?",
                placeholder: "",
                description: "",
            },
            pis_pasep_number: {
                label: "PIS/Pasep Número",
                placeholder: "",
                description: "",
                help: "<a href='https://selecty.movidesk.com/kb/pt-br/article/455803/8-maneiras-de-localizar-seu-pis' target='_blank'>onde localizar o número do  PIS</a>",
            },
            pis_pasep_date: {
                label: "PIS/Pasep Data",
                placeholder: "",
                description: "",
            },
            pis_file_id: {
                label: "Anexar PIS",
                placeholder: "",
                description: "",
            },
        },
        voter: {
            has_voter_registration: {
                label: "Possui Título de Eleitor?",
                placeholder: "",
                description: "",
            },
            voter_registration_number: {
                label: "Número",
                placeholder: "",
                description: "",
            },
            voter_registration_zone: {
                label: "Zona",
                placeholder: "",
                description: "",
            },
            voter_registration_section: {
                label: "Seção",
                placeholder: "",
                description: "",
            },
            voter_registration_state: {
                label: "Estado",
                placeholder: "",
                description: "",
            },
            voter_registration_city: {
                label: "Cidade",
                placeholder: "",
                description: "",
            },
            voter_registration_date: {
                label: "Data de Emissão",
                placeholder: "",
                description: "",
            },
            voter_registration_file_id: {
                label: "Anexar Título de Eleitor (Frente)",
                placeholder: "",
                description: "",
            },
            voter_registration_file2_id: {
                label: "Anexar Título de Eleitor (Verso)",
                placeholder: "",
                description: "",
            },
        },
        armed_forces: {
            has_certificate_armed_forces: {
                label: "Possui Certificado de Reservista?",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_status: {
                label: "Situação",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service: {
                label: "Número RA",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_serie: {
                label: "Série",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_organ: {
                label: "Órgão",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_uf: {
                label: "UF",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_type: {
                label: "Tipo",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_category: {
                label: "Categoria",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_date: {
                label: "Data de Emissão",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_file_id: {
                label: "Anexar Certificado de Reservista (frente)",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_file2_id: {
                label: "Anexar Certificado de Reservista (verso)",
                placeholder: "",
                description: "",
            },
        },
        cnh: {
            has_cnh: {
                label: "Possui Carteira de Motorista?",
                placeholder: "",
                description: "",
            },
            cnh_number: {
                label: "Número",
                placeholder: "",
                description: "",
            },
            cnh_local: {
                label: "Local",
                placeholder: "",
                description: "",
            },
            cnh_organ: {
                label: "Órgão Emissor",
                placeholder: "",
                description: "",
            },
            cnh_state: {
                label: "Estado Emissor",
                placeholder: "",
                description: "",
            },
            cnh_type: {
                label: "Tipo de CNH",
                placeholder: "",
                description: "",
            },
            cnh_date_emission: {
                label: "Data de Emissão",
                placeholder: "",
                description: "",
            },
            cnh_date_validity: {
                label: "Data de Validade",
                placeholder: "",
                description: "",
            },
            cnh_date_first_emission: {
                label: "Primeira emissão",
                placeholder: "",
                description: "",
            },
            cnh_file_id: {
                label: "Anexar CNH (Frente)",
                placeholder: "",
                description: "",
            },
            cnh_file_2_id: {
                label: "Anexar CNH (Verso)",
                placeholder: "",
                description: "",
            },
        },
        bank: {
            has_bank: {
                label: "Possui Conta Bancária no seu nome?",
                placeholder: "",
                description: "",
            },
            bank_name: {
                label: "Nome do Banco",
                placeholder: "",
                description: "",
            },
            bank_type: {
                label: "Tipo de Conta",
                placeholder: "",
                description: "",
            },
            bank_holder_name: {
                label: "Nome do Titular",
                placeholder: "",
                description: "",
            },
            bank_holder_type: {
                label: "Tipo de Titular",
                placeholder: "",
                description: "",
            },
            bank_agency: {
                label: "Agência",
                placeholder: "",
                description: "",
            },
            bank_account: {
                label: "Conta",
                placeholder: "",
                description: "",
            },
            bank_operation: {
                label: "Operação Bancária",
                placeholder: "",
                description: "",
            },
            account_file_id: {
                label: "Anexar Comprovante Conta Bancária (Frente)",
                placeholder: "",
                description: "",
            },
            account_file2_id: {
                label: "Anexar Comprovante Conta Bancária (Verso)",
                placeholder: "",
                description: "",
            },
            bank_pix_type: {
                label: "Tipo de Chave Pix",
                placeholder: "",
                description: "",
            },
            bank_pix_value: {
                label: "Chave PIX",
                placeholder: "",
                description: "",
            },
            bank_account_cnpj_file: {
                label: "Anexo de comprovante de conta PJ",
                placeholder: "",
                description: "",
            },
        },
        dependents: {
            name: {
                label: "Nome completo",
                placeholder: "",
                description: "",
            },
            birth_date: {
                label: "Data de Nascimento",
                placeholder: "",
                description: "",
            },
            gender: {
                label: "Sexo",
                placeholder: "",
                description: "",
            },
            civil_status: {
                label: "Estado Civil",
                placeholder: "",
                description: "",
            },
            kinship: {
                label: "Grau de Parentesco",
                placeholder: "",
                description: "",
            },
            rg: {
                label: "RG",
                placeholder: "",
                description: "",
            },
            cpf: {
                label: "CPF",
                placeholder: "",
                description: "",
            },
            vaccine_number: {
                label: "Caderneta de Vacinação",
                placeholder: "",
                description: "",
            },
            sus_card: {
                label: "Número do Cartão SUS",
                placeholder: "",
                description: "",
            },
            mother_name: {
                label: "Nome da Mãe",
                placeholder: "",
                description: "",
            },
            income_tax: {
                label: "Deseja declarar em seu imposto de renda?",
                placeholder: "",
                description: "",
            },
            life_insurance: {
                label: "Incluir esse dependente como beneficiário de seu seguro de vida?",
                placeholder: "",
                description: "",
            },
            health_care: {
                label: "Incluir esse dependente no plano de Assistência Médica?",
                placeholder: "",
                description: "",
            },
            file_1_id: {
                label: "Anexar Certidão de Nascimento (Frente)",
                placeholder: "",
                description: "",
            },
            file_2_id: {
                label: "Anexar Certidão de Nascimento (Verso)",
                placeholder: "",
                description: "",
            },
            file_3_id: {
                label: "Anexar CPF do Dependente",
                placeholder: "",
                description: "",
            },
            file_4_id: {
                label: "Anexar Declaração de Matrícula Escolar",
                placeholder: "",
                description: "",
            },
            file_5_id: {
                label: "Anexar Comprovante de matrícula Universitária",
                placeholder: "",
                description: "",
            },
            file_6_id: {
                label: "Anexar Declaração de Dependência Econômica Registrada em Cartório",
                placeholder: "",
                description: "",
            },
            file_7_id: {
                label: "Anexar Termo de Tutela",
                placeholder: "",
                description: "",
            },
            file_8_id: {
                label: "Anexar Carteirinha de Vacinação (Frente)",
                placeholder: "",
                description: "",
            },
            file_9_id: {
                label: "Anexar Cartão SUS",
                placeholder: "",
                description: "",
            },
            file_10_id: {
                label: "Anexar Carteirinha de Vacinação (Verso)",
                placeholder: "",
                description: "",
            },
            file_11_id: {
                label: "Anexar RG (frente)",
                placeholder: "",
                description: "",
            },
            file_12_id: {
                label: "Anexar Certidão de Casamento",
                placeholder: "",
                description: "",
            },
            file_13_id: {
                label: "Anexar Laudo PCD",
                placeholder: "",
                description: "",
            },
            file_14_id: {
                label: "Anexar Histórico Escolar",
                placeholder: "",
                description: "",
            },
            file_15_id: {
                label: "Anexar RG (Verso)",
                placeholder: "",
                description: "",
            },
        },
        epi: {
            tshirt: {
                label: "Camiseta",
                placeholder: "",
                description: "",
            },
            trousers: {
                label: "Calça",
                placeholder: "",
                description: "",
            },
            shoe: {
                label: "Calçado",
                placeholder: "",
                description: "Informe o número que você calça",
            },
            jacket: {
                label: "Jaqueta",
                placeholder: "",
                description: "",
            },
            shirt: {
                label: "Camisa",
                placeholder: "",
                description: "",
            },
            suit: {
                label: "Terno",
                placeholder: "",
                description: "",
            },
            helm: {
                label: "Capacete",
                placeholder: "",
                description: "",
            },
            holster: {
                label: "Coldre",
                placeholder: "",
                description: "",
            },
            vest: {
                label: "Colete",
                placeholder: "",
                description: "",
            },
        },
        benefits: {
            benefits: {
                label: "Selecione os benefícios que deseja receber",
                placeholder: "",
                description: "",
            },
            has_transports: {
                label: "Precisa de vale transporte?",
                placeholder: "",
                description: "",
            },
        },
        transports: {
            way_transport: {
                label: "Itinerário",
                description: "",
                placeholder: "",
            },
            type_transport: {
                label: "Tipo de Transporte",
                description: "",
                placeholder: "",
            },
            path_transport: {
                label: "Trajeto",
                description: "",
                placeholder:
                    "Ex: Linha Vermelha do Metrô (Corinthians-Itaquera)",
            },
            value_transport: {
                label: "Valor da passagem (R$)",
                description: "",
                placeholder: "",
            },
        },
        cnpj: {
            has_cnpj: {
                label: "Possui Pessoa Jurídica?",
                placeholder: "",
                description: "",
            },
            cnpj_name: {
                label: "Razão Social",
                placeholder: "",
                description: "",
            },
            cnpj_number: {
                label: "CNPJ",
                placeholder: "",
                description: "",
            },
            cnpj_name_legal_representative: {
                label: "Nome do representante legal",
                placeholder: "",
                description: "",
            },
            cnpj_phone_legal_representative: {
                label: "Telefone do representante legal",
                placeholder: "",
                description: "",
            },
            cnpj_email_legal_representative: {
                label: "E-mail do representante legal",
                placeholder: "",
                description: "",
            },
            cnpj_file: {
                label: "Anexo Cartão CNPJ",
                placeholder: "",
                description: "",
            },
            cnpj_articles_incorporation_file: {
                label: "Anexo contrato social",
                placeholder: "",
                description: "",
            },
            cnpj_operating_license_file: {
                label: "Anexo alvará de funcionamento",
                placeholder: "",
                description: "",
            },
            cnpj_simplified_certificate_file: {
                label: "Anexo de certificado simplificado emitido pela Junta comercial",
                placeholder: "",
                description: "",
            },
            cnpj_rg_legal_representative_front_file: {
                label: "Anexo de RG frente do representante legal",
                placeholder: "",
                description: "",
            },
            cnpj_rg_legal_representative_back_file: {
                label: "Anexo de RG verso do representante legal",
                placeholder: "",
                description: "",
            },
            cnpj_cpf_legal_representative_file: {
                label: "Anexo de CPF do representante legal",
                placeholder: "",
                description: "",
            }
        },
        contacts: {
            contact_name1: {
                label: "Nome 1",
                placeholder: "",
                description: "",
            },
            contact_phone1: {
                label: "Telefone 1",
                placeholder: "",
                description: "",
            },
            contact_name2: {
                label: "Nome 2",
                placeholder: "",
                description: "",
            },
            contact_phone2: {
                label: "Telefone 2",
                placeholder: "",
                description: "",
            },
        },
        forms: {
            transport_form_file_id: {
                label: "Anexar Formulário de Vale Transporte",
                placeholder: "",
                description: "",
            },
            transport_file_id: {
                label: "Cópia do Cartão de Vale Transporte",
                placeholder: "",
                description: "",
            },
            chartered_file_id: {
                label: "Formulário de Fretado",
                placeholder: "",
                description: "",
            },
            salary_family_file_id: {
                label: "Formulário de Salário Familia",
                placeholder: "",
                description: "",
            },
            impost_file_id: {
                label: "Anexar Formulário Imposto de Renda",
                placeholder: "",
                description: "",
            },
            has_contribution_sindical: {
                label: "Deseja realizar Contribuição Sindical?",
                placeholder: "",
                description: "",
            },
            syndicate_contribution_file_id: {
                label: "Anexar Declaração de Adesão à Contribuição Sindical",
                placeholder: "",
                description: "",
            },
            vaccine_file_id: {
                label: "Anexar Carteira de Vacinação",
                placeholder: "",
                description: "",
            },
            unemployment_insurance_file_id: {
                label: "Anexar Comprovante de Seguro Desemprego",
                placeholder: "",
                description: "",
            },
            contribution_inss_file_id: {
                label: "Anexar Comprovante Contribuição INSS",
                placeholder: "",
                description: "",
            },
            other_file_id: {
                label: "Anexar Outros",
                placeholder: "",
                description: "",
            },
            other_file2_id: {
                label: "Anexar Outros",
                placeholder: "",
                description: "",
            },
            other_file3_id: {
                label: "Anexar Outros",
                placeholder: "",
                description: "",
            },
            other_file4_id: {
                label: "Anexar Outros",
                placeholder: "",
                description: "",
            },
        },
    },
    admissional: {
        fill: "Preenchimento",
        section: 'Seção',
        title: "Formulário Admissional",
        onboarding: {
            progress: "Etapa {current} de {total}",
            cpf_hint: "Precisamos do seu CPF para continuar com o formulário admissional.",
            email_title: "Informe seu e-mail",
            email_hint: "Utilizaremos este e-mail para comunicações sobre sua admissão.",
            terms_title: "Termos de uso e privacidade",
        },
        sections: {
            personal: {
                title: "Dados Básicos",
                address: "Dados de Endereço",
                education: "Dados Acadêmicos",
                diversity: "Diversidade e Inclusão",
                passport: "Passaporte"
            },
            ctps: {
                title: "Carteira de Trabalho",
            },
            voter: {
                title: "Título de Eleitor",
            },
            armed_forces: {
                title: "Certificado de Reservista",
            },
            cnh: {
                title: "Carteira de Motorista",
            },
            bank: {
                title: "Dados Bancários",
                generate_bank_letter:
                    "Gere aqui sua carta para abertura de conta bancária",
            },
            dependents: {
                title: "Dependentes",
            },
            transports: {
                title: "Transporte",
            },
            epi: {
                title: "EPI/Uniforme",
            },
            benefits: {
                title: "Benefícios",
            },
            cnpj: {
                title: "Dados de Pessoa Jurídica",
            },
            contacts: {
                title: "Contatos de Emergência",
            },
            forms: {
                title: "Outros Documentos",
            },
        },
    },
    complementary_data: {
        title: "Dados Complementares",
    },
    esocial: {
        title: "Cadastro E-social",
    },
    admission_data: {
        title: "Dados Admissionais",
    },
    vacancy: {
        "no-vacancy": "Não há vagas a serem exibidas",
        filters: {
            text: {
                label: "",
                placeholder:
                    "Pesquise pelas palavras chave como cargo ou empresa",
                description: "",

                occupation: "Cargo",
                interest_area: "Área Profissional",
                activities: "Atividades",
                requirements: "Requisitos",
            },
            location: {
                label: "",
                placeholder: "Localização",
                description: "",
                vacancies_at: "Vagas em:",
            },
            interval: {
                label: "",
                placeholder: "Data de publicação",
                description: "",
                tokens: {
                    anyTime: "Todas as datas de publicação",
                    lastDay: "Últimas 24 horas",
                    lastThreeDays: "Últimos 3 dias",
                    lastWeek: "Última semana",
                    lastMonth: "Últimos 30 dias",
                },
                action_buttons: {
                    redefine: "Redefinir", 
                    see_results: "Ver resultados"
                }
            },
            positions: {
                label: "",
                placeholder: "",
                description: "",
                tokens: {
                    all: "Todas",
                    oneOrMore: "Mais de 1 vaga",
                    fiveOrMore: "Mais que 5 vagas",
                    TenOrMore: "Mais que 10 vagas",
                },
            },
            contract_type: {
                label: "",
                placeholder: "Tipo de contrato",
                description: "",
                tokens: {
                    all: "Todos os tipos de contrato",
                    autonomous: "Autônomo",
                    clt: "CLT (Efetivo)",
                    freeLance: "Free-lancer",
                    juridicPerson: "Prestador de serviço (PJ)",
                    temporary: "Temporário",
                    trainee: "Trainee",
                    internship: "Estágio",
                    apprentice: "Menor aprendiz",
                    diarist: "Diarista",
                    cooperated: "Cooperado",
                    outsourced: "Terceirizado",
                },
            },
            workplace_type: {
                label: "",
                placeholder: "Modalidade de trabalho",
                description: "",
                tokens: {
                    all: "Todas as modalidades de vaga",
                    presential: "Presencial",
                    hybrid: "Híbrido",
                    homeOffice: "Remoto",
                    extern: "Externo",
                },
            },
            professional_area: {
                label: "",
                placeholder: "Área profissional",
                description: "",
                tokens: {
                    all: "Todas as áreas profissionais",
                    interest_areas_1: "Administração Comercial/Vendas",
                    interest_areas_2: "Administração de Empresas",
                    interest_areas_3: "Administração Pública",
                    interest_areas_4: "Advocacia/Jurídica",
                    interest_areas_5: "Agrícola",
                    interest_areas_6: "Agronomia",
                    interest_areas_7: "Alimentos e Bebidas",
                    interest_areas_8: "Arquitetura/Urbanismo",
                    interest_areas_9: "Arquivologia",
                    interest_areas_10: "Artes Cênicas",
                    interest_areas_11: "Artes Gráficas",
                    interest_areas_12: "Artes Plásticas",
                    interest_areas_13:
                        "Atend. a cliente - Bares e Restaurantes",
                    interest_areas_14:
                        "Atend. a cliente - Telefonistas/Recepcionistas",
                    interest_areas_15:
                        "Atend. a cliente - Telemarketing/Call Center",
                    interest_areas_16: "Atend. a cliente",
                    interest_areas_17: "Auditoria",
                    interest_areas_18: "Automação Industrial",
                    interest_areas_19: "Automobilística",
                    interest_areas_20: "Bancos",
                    interest_areas_21: "Biblioteconomia",
                    interest_areas_22: "Biologia/Ciências Biológicas",
                    interest_areas_23: "Biomedicina",
                    interest_areas_24: "Biotecnologia/Bioprocessos",
                    interest_areas_25: "Captação e Fomento",
                    interest_areas_26: "Ciências Sociais",
                    interest_areas_27: "Cinema",
                    interest_areas_28: "Comércio Exterior",
                    interest_areas_29: "Compras",
                    interest_areas_30: "Comunicação",
                    interest_areas_31: "Confecção",
                    interest_areas_32: "Construção Civil",
                    interest_areas_33: "Contabilidade",
                    interest_areas_34: "Controladoria",
                    interest_areas_35: "Culinária/Gastronomia",
                    interest_areas_36: "Cultura",
                    interest_areas_37: "Desenho Industrial",
                    interest_areas_38: "Desenvolvimento de Negócios",
                    interest_areas_39: "Design de Interiores",
                    interest_areas_40: "Design Gráfico",
                    interest_areas_41: "Ecologia/Meio Ambiente",
                    interest_areas_42: "Economia",
                    interest_areas_43: "Educação",
                    interest_areas_44: "Eletroeletrônica",
                    interest_areas_45: "Empreendedorismo Juvenil",
                    interest_areas_46: "Enfermagem",
                    interest_areas_47: "Enfermagem - do Trabalho",
                    interest_areas_48: "Engenharia de Alimentos",
                    interest_areas_49: "Engenharia Civil",
                    interest_areas_50: "Engenharia Eletrônica",
                    interest_areas_51: "Engenharia Eletrotécnica",
                    interest_areas_52: "Engenharia Mecânica",
                    interest_areas_53: "Engenharia Metalúrgica e de Materiais",
                    interest_areas_54: "Engenharia de Minas",
                    interest_areas_55: "Engenharia de Produção",
                    interest_areas_56: "Engenharia Química",
                    interest_areas_57: "Engenharia - Outras",
                    interest_areas_58: "Ensino Superior e Pesquisa",
                    interest_areas_59: "Educação - Ensino Médio / Técnico",
                    interest_areas_60: "Educação - Ensino Fundamental",
                    interest_areas_61: "Educação - Ensino Infantil",
                    interest_areas_62: "Educação - Ensino a Distância",
                    interest_areas_63: "Ensino - Outros",
                    interest_areas_64: "Entretenimento",
                    interest_areas_65: "Esportes",
                    interest_areas_66: "Estética",
                    interest_areas_67: "Eventos",
                    interest_areas_68: "Farmácia",
                    interest_areas_69: "Filosofia",
                    interest_areas_70: "Finanças",
                    interest_areas_71: "Fiscal",
                    interest_areas_72: "Física",
                    interest_areas_73: "Fisioterapia",
                    interest_areas_74: "Florestal",
                    interest_areas_75: "Fonoaudiologia",
                    interest_areas_76: "Geografia",
                    interest_areas_77: "Geologia",
                    interest_areas_78: "Gestão Empresarial",
                    interest_areas_79: "Gestão de Projetos",
                    interest_areas_80: "Gráfica e Editorial",
                    interest_areas_81: "História",
                    interest_areas_82: "Hotelaria",
                    interest_areas_83: "Industrial",
                    interest_areas_84: "Informática/T.I.",
                    interest_areas_85: "Inovação",
                    interest_areas_86: "Internet",
                    interest_areas_87: "Jornalismo",
                    interest_areas_88: "Lazer",
                    interest_areas_89: "Letras",
                    interest_areas_90: "Logística",
                    interest_areas_91: "Madeira e Mobiliário",
                    interest_areas_92: "Manutenção Industrial",
                    interest_areas_93: "Manutenção Predial",
                    interest_areas_94: "Marketing",
                    interest_areas_95: "Matemática/Estatística",
                    interest_areas_96: "Mecatrônica",
                    interest_areas_97: "Medicina/Hospitalar",
                    interest_areas_98: "Metalúrgica",
                    interest_areas_99: "Meteorologia",
                    interest_areas_100: "Mídias Educacionais",
                    interest_areas_101: "Mineração",
                    interest_areas_102: "Minerais não Metálicos",
                    interest_areas_103: "Moda",
                    interest_areas_104: "Museologia",
                    interest_areas_105: "Música",
                    interest_areas_106: "Nutrição",
                    interest_areas_107: "Oceanografia",
                    interest_areas_108: "Odontologia",
                    interest_areas_109: "Orçamento",
                    interest_areas_110:
                        "Organização de Eventos/Produção Cultural",
                    interest_areas_111: "Organização e Métodos",
                    interest_areas_112: "Papel e Celulose",
                    interest_areas_113: "Patrimônio - Gestão",
                    interest_areas_114: "Pesquisa de Mercado",
                    interest_areas_115: "Petrolífera",
                    interest_areas_116: "Plásticos e Polímeros",
                    interest_areas_117: "Produção/Fabricação",
                    interest_areas_118: "Propaganda",
                    interest_areas_119: "Psicologia",
                    interest_areas_120: "Qualidade",
                    interest_areas_121: "Química",
                    interest_areas_122: "Radialismo e Televisão",
                    interest_areas_123: "Recursos Humanos",
                    interest_areas_124: "Refrigeração e Climatização",
                    interest_areas_125: "Relações Internacionais",
                    interest_areas_126: "Relações Públicas",
                    interest_areas_127: "Responsabilidade Social",
                    interest_areas_128: "Secretariado",
                    interest_areas_129: "Segurança e Saúde no Trabalho",
                    interest_areas_130: "Segurança Patrimonial",
                    interest_areas_131: "Seguros",
                    interest_areas_132: "Serviço Social",
                    interest_areas_133: "Serviços Administrativos",
                    interest_areas_134: "Serviços Domésticos",
                    interest_areas_135: "Serviços Especializados - Açougue",
                    interest_areas_136:
                        "Serviços Especializados - Padaria/Confeitaria",
                    interest_areas_137: "Serviços Especializados - Peixaria",
                    interest_areas_138: "Serviços Gerais",
                    interest_areas_139: "Serviços Técnicos - Elétricos",
                    interest_areas_140: "Serviços Técnicos - Eletrônicos",
                    interest_areas_141: "Serviços Técnicos - Mecânicos",
                    interest_areas_142: "Serviços Técnicos - Outros",
                    interest_areas_143: "Suprimentos",
                    interest_areas_144: "Telecomunicações",
                    interest_areas_145: "Terapia Ocupacional",
                    interest_areas_146:
                        "Terceiro Setor/Responsabilidade Social",
                    interest_areas_147: "Tradução/Interpretação",
                    interest_areas_148: "Transporte - Gestão",
                    interest_areas_149: "Transporte Aéreo",
                    interest_areas_150: "Transporte Marítimo",
                    interest_areas_151: "Transporte Terrestre",
                    interest_areas_152: "Transporte Ferroviário",
                    interest_areas_153: "Treinamento e Orientação Profissional",
                    interest_areas_154: "Tributária",
                    interest_areas_155: "Turismo",
                    interest_areas_156: "Vendas",
                    interest_areas_157: "Vendas - Varejo",
                    interest_areas_158: "Vendas Técnicas",
                    interest_areas_159: "Veterinária",
                    interest_areas_160: "Viagens",
                    interest_areas_161: "Web Design",
                    interest_areas_162: "Zoologia",
                    interest_areas_163: "Zootecnia",
                    interest_areas_164: "Trade Marketing",
                },
            },
            companies: {
                label: "",
                placeholder: "Empresas",
                description: "",
            },
            tags: {
                label: "",
                placeholder: "Tag's",
                description: "",
            },
            results:
                "Nenhum resultado encontrado | <b>{count} vaga</b> encontrada | <b>{count} vagas</b> encontradas",
            with_positions: "totalizando <b>{count} posição</b> | totalizando <b>{count} posições</b>",
            count_paginated_results: "Mostrando {count} de ",
            count_all_results: "{count} resultados",
        },
        share: {
            title: "Compartilhar",
            tw: { label: "Twitter" },
            fb: { label: "Facebook" },
            lk: { label: "Linked In" },
            whatsapp: { label: "Whats app" },
        },
        actions: {
            share: "Compartilhar",
            apply: "Candidatar-se",
            "already-applied": "Candidatado",
            "see-vacancy": "Ver vaga",
            seeAllVacancies: "Ver todas as vagas",
            seeOurVacancies: "Veja todas as nossas vagas!",
            seeOpenPositions: "Ver vagas em aberto",
            copy: "Copiar",
            save: "Salvar",
            favorite: "Favoritar vaga",
            unfavorite: "Desfavoritar vaga",
            saved: "Salva",
            favorite_success: "Vaga favoritada com sucesso!",
            please_login_to_favorite: "Faça o login para favoritar a vaga!",
            favorite_failure: "Falha ao favoritar a vaga!",
            none_favorite_vacancy: "Sem vagas favoritas",
            almost_there: "Quase lá!",
            needed_information_to_complete:
                "As informações abaixo são necessárias para completar a sua candidatura.",
            keep_looking_vacancies:
                "Dê uma olhada em mais oportunidades e adicione à sua lista de favoritas as que mais combinam com seu perfil.",
            save_vacancy: "Salvar vaga",
            log_to_save: "Faça login para poder salvar essa vaga",
            log_to_apply: "Faça login para poder se candidatar a essa vaga",
            remove_favorite: "Remover vaga dos favoritos",
        },
        texts: {
            pcd: {
                info: "Vagas destinada a pessoas portadoras de deficiência",
            },
        },
        shareJob: "Compartilhe esta vaga",
        codVacancy: "Cód. da Vaga:",
        jobsQuantity: "Número de vagas:",
        contract_type: "Tipo de contratação: ",
        interest_area: "Área profissional : ",
        workload: "Carga horária: ",
        work_schedule: "Jornada de trabalho: ",
        salary: "Salário: ",
        copyLink: "Ou copie o link",
        location: "Localização: ",
        company: "Empresa",
        pcd: "Vaga PCD?",
        workplace_type: "Modalidade de trabalho: ",
        process_type: "Tipo de processo: ",
        pcdInfo: "Tipos de PCD:",
        search: "Pesquisar",
        lastDay: "Últimas 24 horas",
        lastThreeDays: "Últimos 3 dias",
        lastWeek: "Última semana",
        lastMonth: "Últimos 30 dias",
        anyTime: "A qualquer momento",
        moreThan: "mais de ",
        anyJobsQuantity: "Qualquer quantidade de vagas",
        cleanFilters: "Limpar filtros",
        jobs: "vagas",
        apply: "Candidatar-se",
        about: "Sobre nós",
        vacancy_info: "Dados da vaga",
        responsabilities: "Responsabilidades e atribuições",
        requirements: "Requisitos e qualificações",
        desirable: "Desejável",
        benefits: "Benefícios",
        additional_info: "Informações adicionais",
        keep_searching:
            "Continue procurando e experimente outros termos e filtros para encontrar a vaga ideal para você.",
        empty_vacancy: "Nenhuma oportunidade encontrada",
        vacancy_not_found: "Vaga não encontrada",
        published_at: " Publicada há ",
        published_days: "dia | dias",
        days_ago: "",
        published_at_x_days: " N/A|Publicada há {n} dia|Publicada há {n} dias",
        published_hours: "N/A|1 hora|{count} horas",
        vacancies: "vaga | vagas",
        positions: "posição | posições"
    },
    vacancy_by_city: "Vagas por cidade",
    vacancy_by_area: "Vagas por área",
    vacancy_by_occupation: "Vagas por cargo",
    home: {
        sections: {
            vacancies: {
                title: "Vagas em destaque",
            },
        },
        resume: "Currículo",
        "active-vacancies": "Sem vagas | 1 vaga ativa | {count} vagas ativas",
        "pending-items": "Sem pendências | 1 pendência | {count} pendências",
        "unread-messages": "1 não lida | {count} não lidas",

        completeness: "preenchido",
        messages: "Mensagens",

        welcome_msg: "Bem vindo a home",
        hi: "Olá",
        follow: "acompanhar",
        currentJobs: "Você está participando de",
        jobs: "vagas",
        profileJobs: "Vagas que se encaixam no seu perfil",
        appointments: "Compromissos",
        curriculum: {
            empty: "Seu currículo está um pouco vazio",
            half: "Falta pouco para completar seu currículo",
            full: "Seu currículo está completo",
            complete: "Completar seu currículo",
            review: "Revisar currículo",
            follow: "Acompanhar",
        },
        more_than: "Mais de",
        job_opportunities: "oportunidades de trabalho!",
        success_key: "Use o SelectyJobs como sua chave para o sucesso!",
        supportive_partner: "Aqui você tem um parceiro para te apoiar nesse momento tão importante que é a busca pelo seu próximo trabalho!",
        free_for_candidates: "100% gratuito para candidatos!",
        unlimited_applications: "Sem limite de candidaturas",
        meaningful_stages: "Somente etapas que fazem sentido",
        real_jobs: "Vagas reais em empresas reais",
        profile_visibility: "Seu perfil profissional sendo visto e consultado por milhares de empresas!"

    },
    registration: {
        placeholders: {
            "email-or-cpf": "",
        },
        hello: "Olá, {0}",
        lets_go: "Vamos lá, {0}",
        congratulations_text: "Que bom que encontrou uma oportunidade!",
        account_not_found:
            "Não encontramos uma conta registrada para este CPF, deseja se cadastrar?",
        candidacy_start: "Vamos iniciar sua candidatura",
        create_mini_curriculum: "Preencha seu mini currículo para continuar",
        hasAccount: "Já tem uma conta?",
        login: "Entre aqui",
        fullName: "Nome completo",
        typeFullName: "Digite o seu nome completo",
        createPassword: "Crie uma senha",
        lowerLetter: "Uma letra minúscula",
        upperLetter: "Uma letra maiúscula",
        number: "Um número",
        specialChar: "Um caractere especial",
        eightChars: "8 caracteres no mínimo",
        agree_with: "Ao clicar em começar, você aceita",
        as: "as",
        specific_policies: "Políticas Específicas",
        from_company: "da empresa",
        os: "os",
        terms_and_conditions: "Termos e Condições",
        and_the: "e a",
        privacy_policy: "Política de Privacidade",
        from_selecty_platform: "da plataforma Selecty",
        continue: "Continuar",
        start: "Começar",
        createAccount: "Aceite e cadastre-se",
        confirmPassword: "Confirme a sua senha",
        finish_your_account_creation: "Finalize a criação da sua conta",
        you_need_your_account_to_check:
            "Você precisa dela para acompanhar suas candidaturas",
        lets_create_your_password: "Vamos criar sua senha",
        you_will_need_it_to_access_your_account: "Você precisará dela para acessar sua conta"
    },
    communication: {
        confirmation:
            "Recebemos sua solicitação e iremos analisar assim que possível.",
        error: "Ocorreu um erro ao enviar sua solicitação, tente novamente mais tarde.",
        almost_done: "Estamos quase lá!",
        invalid_token: {
            title: "Falha!",
            text: "Token inválido! Tente novamente mais tarde.",
        },
        request_sent: {
            title: "Tudo certo!",
            text: "Obrigado! Recebemos sua solicitação e iremos analisar assim que possível.",
        },
        email_confirm: {
            title: "Estamos quase lá!",
            text: "Enviamos um link de verificação em seu e-mail para poder registrar o contato, o link tem uma validade de 15 minutos.",
        },
    },
    confirm_communication: {
        loading: {
            title: "Estamos registrando seu contato",
            text: "Por favor aguarde...",
        },
    },
    feedback: {
        communication: {
            success: "Muito obrigado! Recebemos seu feedback.",
            confirmation:
                "Por favor, confirme seu e-mail para registrar seu contato.",
        },
        modal: {
            title: "Gostaríamos de pedir a sua colaboração contando para nós como foi sua experiência.",
            question_1: "De 0 a 5, como você avalia a facilidade de cadastrar seus dados?",
            question_2: "De 0 a 5: Como você avalia a clareza das informações?",
            question_3: "De 0 a 5: Como você avalia as informações encontradas sobre sua candidatura realizada?"
        },
        rating_0: {
            name: "rating_0",
            label: "",
        },
        rating_1: {
            name: "rating_1",
            label: "",
        },
        rating_2: {
            name: "rating_2",
            label: "",
        },
        feedback_scale_labels: {
            very_hard: "Muito difícil",
            hard: "Difícil",
            medium: "Médio",
            easy: "Fácil",
            very_easy: "Muito fácil"
        },
        results: {
            default: "Conta pra nós como foi sua experiência",
            bad: "Que pena 🙁! Conta pra nós como foi sua experiência",
            good: "Que ótimo 😄! Conta pra nós como foi sua experiência"
        },
    },
    help: {
        button: {
            message: "Precisa de Ajuda?",
        },
        communication: {
            success:
                "Recebemos a sua dúvida. Assim que possível, você será contactado.",
            confirmation:
                "Por favor, confirme seu e-mail para registrar seu contato.",
        },
        modal: {
            title: "Dúvidas, Sugestões, por favor entre em contato",
        },
        message: {
            name: "Mensagem",
            placeholder: "Deixe a sua mensagem",
            label: "Conte para nós o que aconteceu",
            description:
                "Prometemos não utilizar suas informações de contato para enviar qualquer tipo de SPAM.",
        },
        confirmation_mail: {
            title: "Obrigado por confirmar seu e-mail!",
        },
    },
    messages: {
        search: "Buscar mensagens",
        noMessagesFound: "Sua caixa de mensagens está vazia",
        subject: "Assunto:",
        noSubject: "(sem assunto)",
        earlierMessages: "Mensagens anteriores",
        all: "Todas",
        read: "Lidas",
        unread: "Não Lidas",
        reply: "Responder",
        reply_message: "Digite sua mensagem de resposta e clique em responder",
        edited_five_minutes: "Você editou há 5 minutos",
        edited_three_minutes: "Você editou há 3 minutos",
        message_sent_successfully: "Mensagem enviada com sucesso",
        message_sending_failed: "Falha ao enviar mensagem",
    },
    chat: {
        startConversation: "Iniciar Conversa",
        send: "Enviar",
    },
    config: {
        title: "Configurações da conta",
        shortTitle: "Conta",
        notificationsTitle: "Notificações",
        linkAccount: "Vincular conta",
        password: {
            changePassword: "Mudar senha",
            savePassword: "Salvar senha",
            actualPassword: "Senha atual",
            informActualPassword: "Informe sua senha atual",
            newPassword: "Nova senha",
            informNewPassword: "Informe uma nova senha",
            confirmPassword: "Confirmação de senha",
            informConfirmPassword: "Confirme sua nova senha",
        },
        email: {
            changeEmail: "Mudar seu e-mail",
            saveEmail: "Salvar e-mail",
            newEmail: "Novo e-mail",
            informNewEmail: "Informe o novo e-mail",
            confirmeNewEmail: "Confirme o novo e-mail",
            answer_message: "Digite sua mensagem de resposta e clique em 'responder'",
        },
        notifications: {
            push: {
                title: "Notificações push",
                description:
                    "Receba notificações push sobre novas vagas, mensagens e andamento de processos seletivos.",
            },
            email: {
                title: "Notificações via e-mail",
                description:
                    "Receba atualizações via email sobre novas vagas, mensagens e andamento de processos seletivos.",
            },
            whatsapp: {
                title: "Notificações via Whatsapp",
                description:
                    "Receba atualizações via WhatsApp sobre novas vagas, mensagens e andamento de processos seletivos.",
            },
        },
        dataPrivacy: {
            title: "Privacidade de dados",
            description1: "Você também poderá ",
            description2: "exercer todos os direitos dos titulares ",
            description3: "previstos na Lei Geral de Proteção de Dados – LGPD.",
            seePrivacyPolicy: "Ver política de privacidade",
        },
        cancelAccount: {
            title: "Cancelamento da conta",
            btnCancelAccount: "Cancelar Conta",
            description1: "O cancelamento da conta é um processo ",
            description2: "irreversível ",
            description3: "que apagará seus dados do sistema",
            description4: "Esta ação não pode ser desfeita.",
            confirmInstruction:
                "Para confirmar o cancelamento, digite a palavra <b>{word}</b> no campo abaixo.",
            confirmWord: "excluir",
        },
    },
    candidature_origin_id: {
        label: "Como você encontrou esta oportunidade?",
        placeholder: "",
        description: "Selecione uma opção para concluir sua candidatura.",
    },
    application: {
        status: {
            NOT_DEFINED: "Não aplicável",
            STATUS_NOT_ACCEPTED: "Não selecionado no Processo Seletivo",
            STATUS_EXCLUDED: "Currículo não selecionado para oportunidade",
            STATUS_LEAVE: "Desistiu do Processo Seletivo",
            STATUS_CALLED: "Participando do Processo Seletivo",
            STATUS_ACCEPTED: "Participando do Processo Seletivo",
            STATUS_WAITING: "Currículo em análise para oportunidade",
            STATUS_NOT_CONTACTED: "Currículo em análise para oportunidade",
            STATUS_THINKING: "Currículo em análise para oportunidade",
            STATUS_NOT_ATTEND: "Candidato não compareceu para entrevista",
            STATUS_NO_PROFILE: "Currículo não selecionado para oportunidade",
            STATUS_HIRED: "Aprovado no Processo Seletivo",
            STATUS_HIRING: "Aprovado no Processo Seletivo",
            STATUS_DISAPPROVED: "Não selecionado no Processo Seletivo",
            STATUS_APPROVED: "Participando do Processo Seletivo",
            STATUS_ACCEPTING: "Candidatado à oportunidade",
            STATUS_HIRED_CANCELED: "Não selecionado no Processo Seletivo",
            STATUS_HIRED_REPLACEMENT: "Não selecionado no Processo Seletivo",
        },
        applications: "Candidaturas",
        favorites: "Favoritas",
        title: "Minhas Vagas",
        progress: "Progresso da vaga",
        jobDetail: "Ver detalhes da vaga",
        applicationStep: "Você está na fase de candidatura",
        completeSteps: "Complete as etapas abaixo para prosseguir",
        candidacy_complete:
            "Complemente seu currículo para aumentar as chances de ser encontrado.",
        candidacy_confirmed: "Candidatura confirmada!",
        candidacy_failure: "Candidatura pendente!",
        start: "Iniciar",
        startInfo:
            "Para iniciar esta etapa você precisa concluir a etapa anterior",
        nextStep: "Próxima fase",
        completeMessage:
            "Ao completar a trilha de candidatura você passa para a próxima fase do processo seletivo",
        myApplications: "Minhas Vagas",
        curriculumStep: "Preenchimento do Currículo",
        quit: "Desistir",
        seeProgress: "Ver progresso",
        noVacancyEnrolled:
            "Você não está participando de nenhum processo seletivo",
        searchForVacancies: "Buscar Vagas",

        confirming_enrollment: "Confirmando Candidatura",
        we_wish_you_very_luck: "Te desejamos toda a sorte do mundo!",
        confirmed_enrollment: "Candidatura Confirmada",
        you_can_now_do_the_next_steps:
            "Agora você pode dar os próximos passos no processo seletivo",
        see_next_steps: "Ver Próximos passos",
        fill_my_curriculum: "Complementar meu currículo",
        none_application_yet: "Nenhuma candidatura ainda",
        keep_searching:
            "Continue pesquisando e adicionando vagas à sua lista de favoritos.",
        status_application: "Status: ",
        applied_for_job: "Candidatou-se para esta vaga em {date}",
        application_completed_on: "Candidatura realizada em {date}.",
        additional_questions: "Existem perguntas complementares para realizar esta candidatura",
        completed_on: "Candidatura realizada em {date}. <br /> Preencha a <a href='{url}'>Ficha Admissional da Vaga.</a>",
        awaiting_completion: "Aguardando finalização do processo seletivo",
        not_approved: "Não aprovado no processo seletivo",
        test_completed_on: "Questionário finalizado em {date}",
        not_applied_for_job: "Você não está candidatado para esta vaga",
        incomplete_fields: "Nem todos os campos foram preenchidos. Por favor complete os campos abaixo para validar a sua candidatura:",
        resume_completed: "Parabéns! Você preencheu seu currículo!",
        origin_question: "Como você encontrou esta oportunidade?",
        origin_question_hint: "Selecione uma opção para concluir sua candidatura.",
        origin_required: "Selecione como você encontrou esta oportunidade.",
        conclude_application: "Concluir candidatura"
    },
    lgpd: {
        title: "Formulário de Requisição de Direitos do Titular de Dados Pessoais",
        subtitle:
            "Orientações Gerais Disponibilizamos este formulário fundamentado legalmente pelo Art.18 da LGPD, para facilitar o exercício dos seus direitos previstos na Lei Geral de Dados Pessoais (LGPD). Lembramos de que a utilização deste formulário é facultativa, mas se trata de uma forma eficiente e segura para o processamento do seu pleito. Após o preenchimento do formulário ele será encaminhado, juntamente com o(s) comprovante(s) de identidade do requerente, para a área de proteção de dados da empresa.",
        btn_finish: "Finalizar",
        confirmTitle: "Confirmar solicitação",
        confirmDescription:
            "Ao avançar, sua solicitação será enviada e não poderá ser desfeita. Dependendo do direito que você escolheu exercer, isso pode resultar na <b>exclusão dos seus dados</b>.",
        confirmInstruction:
            "Esta é uma ação irreversível. Se deseja continuar, digite a palavra <b>{word}</b>.",
        confirmWord: "confirmar",
        declaration_of_authenticity: {
            label: "Declaração de Autenticidade das informações prestadas",
            placeholder: "",
            description:
                "DECLARO, sob as penas da lei penal e, sem prejuízo das sanções administrativas e cíveis, que as cópias dos documentos anexados ao presente documento são autênticas e condizem com o documento original.",
        },
        data_holder: {
            label: "Você é o titular dos dados ou procurador/representante?",
            placeholder: "",
            description: "",
        },
        sections: {
            personal_data_holder: {
                title: "Qualificações do Titular de Dados Pessoais",
                subtitle:
                    "Preencha os espaços abaixo com as qualificações do titular de dados pessoais.",
            },
            identity_comprovation: {
                title: "Comprovação da Identidade do Titular de Dados Pessoais",
                subtitle:
                    "Solicitamos que seja anexado ao pedido o comprovante de identidade do titular de dados pessoais. Serão aceitos como documentos de identidade civil o RG, o passaporte, a carteira profissional ou quaisquer outros documentos que conste a qualificação e a foto do requisitante. Caso o documento de identidade civil não seja anexado a este formulário, a Selecty poderá solicitar informações adicionais ao titular de dados pessoais, a fim de poder atender à referida demanda.",
            },
            data_holder_rights: {
                title: "Direitos do Titular de Dados Pessoais: Quais  direitos você desejaria exercer?",
                subtitle:
                    'Selecione "Sim" somente para os que deseja exercer neste momento.',
            },
            data_holder_rights_actions: {
                title: "Direitos dos Titulares",
                subtitle: "",
            },
            data_request: {
                title: "Para auxiliar a Selecty a responder a sua requisição de maneira rápida e eficiente, solicitamos, por gentileza, que você nos forneça o máximo de detalhes das informações solicitadas. Por favor, especifique, detalhadamente, seu requerimento aqui:",
                subtitle: "",
            },
            result_request: {
                title: "Comunicação do Resultado do Requerimento",
                subtitle: "",
            },
            legal_agent_qualifications: {
                title: "Qualificações do Procurador ou Representante Legal do Titular de Dados Pessoais (caso se aplique)",
                subtitle:
                    "Preencha os espaços abaixo com as qualificações do procurador ou representante legal do titular de dados pessoais (caso se aplique).",
            },
            comprovation_power_grant: {
                title: "Comprovação da outorga ou delegação de poderes a terceiros (caso se aplique)o sem título",
                subtitle:
                    "Solicitamos que seja anexado ao pedido o comprovante de identidade do procurador ou do representante legal do titular de dados pessoais, bem como o instrumento legal de representação ou a prova de representação parental. Serão aceitos como documentos de identidade civil o RG, o passaporte, a carteira profissional ou quaisquer outros documentos que conste a qualificação e a foto do procurador ou representante legal do titular de dados pessoais. Caso o documento de identidade civil ou o instrumento legal de representação não sejam anexados a este formulário, a Selecty poderá solicitar informações adicionais ao requisitante ou ao seu representante legal do titular de dados pessoais, a fim de poder atender à referida demanda.",
            },
        },
        data_holder_name: {
            label: "Nome completo do titular de dados pessoais",
            placeholder: "",
            description: "",
        },
        data_holder_cpf: {
            label: "CPF do titular de dados pessoais",
            placeholder: "",
            description: "",
        },
        data_holder_phone: {
            label: "Telefone de Contato do titular de dados pessoais",
            placeholder: "",
            description: "",
        },
        data_holder_email: {
            label: "E-mail de Contato do titular de dados pessoais",
            placeholder: "",
            description: "",
        },
        data_holder_category: {
            label: "Categoria do titular de dados pessoais",
            placeholder: "",
            description: "",
        },
        data_holder_additional_info: {
            label: "Explique sua solicitação",
            placeholder: "",
            description:
                "Informe detalhes sobre sua solicitação do exercício do direito do titular.",
        },
        data_holder_document: {
            label: "Anexar documento de identidade civil",
            placeholder: "",
            description: "CPF, RG ou CNH",
        },
        confirm_treatment_data: {
            label: "Deseja confirmar a existência de tratamento de seus dados pessoais?",
            placeholder: "",
            description:
                "Permite saber se a Selecty realizou qualquer tipo de tratamento de seus dados pessoais, ainda que não se tenha certeza se você foi atendido ou se teve algum tipo de relação anterior com a nossa empresa. Art.18, I, LGPD.",
        },
        confirm_access_data: {
            label: "Deseja ter acesso aos seus dados?",
            placeholder: "",
            description:
                "Permite saber sobre o tratamento de dados pessoais realizado pela Selecty. Esse item deve ser assinalado apenas se você já foi atendido ou teve algum tipo de relação anterior com a nossa empresa. Art.18, II, LGPD.",
        },
        hide_data: {
            label: "Deseja eliminar, anonimizar ou bloquear seus dados?",
            placeholder: "",
            description:
                "Permite a anonimização, bloqueio ou eliminação de dados desnecessários, excessivos, tratados em desconformidade com a LGPD ou fornecidos mediante consentimento. Art.18, IV e VI, LGPD. Caso algum dado pessoal não possa ser eliminado, anonimizado ou bloqueado, em razão da necessidade de tratamento para cumprimento de obrigação legal, execução de contrato ou qualquer outro motivo, lhe informaremos.",
        },
        exercise_rights: {
            label: "Caso você já saiba da existência de tratamento dos seus dados pessoais pela Selecty ou ela venha a ser confirmada, quais direitos você gostaria de exercer?",
            placeholder: "",
            description: "",
        },
        data_request: {
            label: "Se possível, gostaríamos que você nos informasse os períodos específicos, horários, datas, nomes, tipos de documentos ou quaisquer outras informações acerca da requisição. Lembre-se de que a Selecty poderá entrar em contato com o requisitante ou seu procurador para solicitar informações adicionais, no caso de a requisição não estar clara o suficiente.",
            placeholder: "",
            description: "",
        },
        result_request: {
            label: "Como você gostaria de ser comunicado acerca do resultado da sua requisição?",
            placeholder: "",
            description: "",
        },
        legal_agent_name: {
            label: "Nome completo do procurador ou do representante legal",
            placeholder: "",
            description: "",
        },
        legal_agent_cpf: {
            label: "CPF do procurador ou do representante legal",
            placeholder: "",
            description: "",
        },
        legal_agent_address: {
            label: "Endereço do procurador ou do representante legal",
            placeholder: "",
            description: "Rua, Número, Complemento, CEP, Cidade, Estado",
        },
        legal_agent_phone: {
            label: "Telefone de contato do procurador ou do representante legal",
            placeholder: "",
            description: "Telefone com DDD no formato XX XXXXX-XXXX",
        },
        legal_agent_email: {
            label: "E-mail de contato do procurador ou do representante legal",
            placeholder: "",
            description: "",
        },
        legal_agent_document: {
            label: "Comprovante de identidade do procurador ou do representante legal do titular de dados pessoais",
            placeholder: "",
            description: "",
        },
        legal_agent_representative_document: {
            label: "Instrumento legal de representação ou a prova de representação parental",
            placeholder: "",
            description: "",
        },
    },
    disc: {
        profile: {
            achiever: "Realizador",
            agent: "Representante",
            appraiser: "Avaliador",
            counselor: "Conselheiro",
            creative: "Criativo",
            developer: "Desbravador",
            inspirational: "Inspirador",
            investigator: "Investigador",
            "objective thinker": "Pensador Objetivo",
            overshift: "Expandido",
            perfectionist: "Perfeccionista",
            persuader: "Convincente",
            practitioner: "Praticante",
            promoter: "Promotor",
            "result-oriented": "Orientado a Resultados",
            specialist: "Especialista",
            tight: "tight",
            undershift: "Comprimido",
        },
        question: {
            I_am: "Sou uma pessoa...",
            More: "Mais",
            Less: "Menos",
            Enthuastic: "Entusiasta",
            Daring: "Audaciosa",
            Diplomatic: "Diplomática",
            Satisfied: "Cooperativa",
            Cautious: "Cautelosa",
            Determined: "Determinada",
            Convicing: "Convincente",
            "Good Natured": "Boa ouvinte",
            Friendly: "Que fala muito e faz amigos",
            Accurate: "Que fala de forma precisa e específica",
            Outspoken: "Que fala de forma franca e sem rodeios",
            Calm: "Que fala calmamente",
            Talkative: "Conversadora",
            Controlled: "Controlada",
            Conventional: "Apoiadora",
            Decisive: "Decidida",
            Adventurous: "Aventureira",
            Insightful: "Perspicaz",
            "Out-going": "Espontânea",
            Moderate: "Moderada",
            Gentle: "Gentil",
            Persuasive: "Persuasiva",
            Humble: "Cuidadosa",
            Original: "Ousada",
            Expressive: "Expressiva",
            Conscientious: "Consciente",
            Dominant: "Com iniciativa",
            Responsive: "Compreensiva",
            Poised: "Com bom humor",
            Observant: "Analítica",
            Modest: "Mediadora",
            Inpatient: "Impaciente",
            Tactful: "Disciplinada",
            Agreeable: "Solidária",
            Magnetic: "Encantadora",
            Insistent: "Pioneira",
            Brave: "Valente",
            Inspiring: "Inspiradora",
            Submissive: "Leal",
            Timid: "Tímida",
            Reserved: "Minuciosa",
            Obliging: "Prestativa",
            "Strong-willed": "Rápida e objetiva",
            Cheerful: "Criativa",
            Stimulating: "Que gosta de muita interação",
            Kind: "Gentil",
            Perceptive: "Muito atenta aos detalhes",
            Independent: "Independente",
            Competitive: "Competitiva",
            Considerate: "Ponderada",
            Joyful: "Popular",
            Private: "Discreta",
            Fussy: "Que pensa objetivamente",
            Obedient: "Que segue processos",
            Firm: "Exigente",
            Playful: "Brincalhona",
            Attractive: "Agradável ",
            Instropective: "Instrospectiva",
            Stubborn: "Teimosa",
            Predictable: "Estável",
            Logical: "Que segue a lógica",
            Bold: "Corajosa",
            Loyal: "Fiel",
            Charming: "Que tenta agradar a todos",
            Sociable: "Sociável",
            Patient: "Paciente",
            "Self-reliant": "Auto-suficiente",
            "Soft spoken": "Que busca precisão",
            Wiling: "Apaziguadora",
            Eager: "Que busca ação e rapidez",
            Thorough: "Meticulosa",
            "High-spirited": "Espirituosa",
            Aggressive: "Que busca objetividade",
            Extroverted: "Extrovertida",
            Amiable: "Amável",
            Fearful: "Que planeja cada passo",
            Confident: "Confiante",
            Sympathetic: "Simpática",
            Impartial: "Imparcial",
            Assertive: "Que vai direto ao ponto",
            "Well-desciplined": "Muito disciplinada",
            Generous: "Tranquila",
            Animated: "Animada",
            Persistent: "Persistente",
            Impulsive: "Impulsiva",
            Introverted: "Introvertida",
            Forceful: "Incisiva ",
            "Easy-going": "Previsível",
            "Good mixer": "Que conecta e integra as pessoas",
            Refined: "Observadora e crítica",
            Vigorous: "Enérgica",
            Lenient: "Tolerante ",
            Captivating: "Que transmite conhecimento",
            Contented: "Que busca ouvir a todos",
            Demanding: "Que direciona as ações",
            Compliant: "Que cria procedimentos",
            Argumentative: "Que argumenta para convencer",
            Systematic: "Que analisa as informações",
            Cooperative: "Que apoia para resolver",
            "Light-hearted": "Que interage e conversa com todos",
            Jovial: "Expansiva",
            Precise: "Detalhista",
            Direct: "Que assume riscos calculados",
            "Even-tempered": "Serena e equilibrada",
            Restless: "Inquieta",
            Neighborly: "Atenciosa",
            Appealing: "Entusiasmada",
            Careful: "Pensativa",
            Respectful: "Com foco no processo e planejamento",
            Pioneering: "Com foco na ação e resultado",
            Optimistic: "Com foco nas possibilidades e na inovação",
            Helpful: "Com foco no grupo e na cooperação",
        },
        form: {
            welcome: "Seja bem-vindo a sua avaliação.",
            instructions:
                "Por favor, clique em continuar e siga as instruções.",
            hello_user: "Olá {0}",
            lets_try_again: "Começar novamente",
            warning_recording_again:
                "O vídeo gravado anteriormente para a pergunta não foi salvo no sistema, por favor tente novamente",
            "time-to-response": "para resposta",
            minutes: "{0} min.",
            seconds: "{0} seg",
            "testing-your-camera": "Testando a sua câmera",
            "i-can-see-me-and-the-quality-is-good":
                "Me vejo e a qualidade está boa.",
            "testing-your-audio": "Testando o seu áudio",
            "i-can-hear-me-and-the-quality-is-good":
                "Me ouço e a qualidade está boa.",
            congratulations: "Parabéns {0}",
            "you-finished": "Você concluiu o questionário",
            "wait-return": "Aguarde o retorno do selecionador",
            "to-start": "para começar",
            "answer-now": "Responder agora",
            start: "Começar",
            continue: "Continuar",
            "ok-already-answered": "Pronto, já respondi",
            "all-working": "Tudo funcionando",
            "have-a-good-interview": "Tenha uma boa entrevista",
            question: "Questão",
            of: "de",
            disc_behavioural_profile: "Perfil Comportamental DISC",
            "you-are-here-to-discover-your-behavioral-disc-profile":
                "Você está aqui para descobrir seu perfil comportamental DiSC.",
            "what-is-it-for": "Para que serve",
            "your-behavioral-profile-will-help-you-understand-how you-work-on-a-team-and-even-in-life-in-general":
                "Seu perfil comportamental vai te ajudar a entender como você se comporta em um time e na vida de forma geral.",
            "lets-begin": "Vamos começar",
            "there-will-be-28-quick-questions": "Serão 28 questões rápidas",
            "see-more-instructions-next": "Veja mais instruções a seguir",
            "skip-and-start-the-test": "Pular e começar o teste",
            "youve-completed-more-than-half-of-the-test":
                "Você já completou mais da metade do teste",
            "How_was_the_test?": "Como foi realizar o teste?",
            thanks_for_your_feedback: "Agradecemos pelo feedback!",
            we_will_do_our_best_to_improve_your_user_experience:
                "Vamos dar o máximo para melhorar sua experiência de uso",
            understood: "Entendi",
            start: "Começar",
            disc_invalid_profile_message:
                "Com base nas respostas fornecidas, não foi possível enquadrar seu perfil comportamental nos padrões estabelecidos pela metodologia DISC.",
            remake_evaluation:
                "Precisamos que você refaça a avaliação para que seu perfil seja identificado e você avance neste processo de Recrutamento e Seleção no qual está candidatado.",
            disc_denied_message_intro:
                "Por enquanto, não é necessário realizar seu DISC novamente!",
            disc_denied_message_body:
                "Você respondeu ao inventário comportamental DISC nos últimos 6 meses e o seu último resultado ainda está dentro da validade.",
            disc_denied_message_conclusion:
                "Essa medida é adotada para assegurar a consistência e transparência do nosso processo. Agradecemos muito pela sua compreensão!",
            execution_date: "Realizado em",
            valid_until: "Vigente até",
        },
        questions: {
            self_knowledge_activity: "A atividade a seguir pode te ajudar a se conhecer ainda mais.",
            next: "Próximo",
            no_right_or_wrong: "Aqui não há certo ou errado.",
            profile_snapshot: "Ao finalizar, você verá um retrato atual do seu perfil e pode usar isto para desenvolver suas habilidades comportamentais.",
            instructions: "Instruções",
            choose_words: "<p>Para cada grupo de palavras, escolha a que <b>mais combina com você</b> e a que <b>menos combina com você</b>.</p>",
            back: "Voltar",
            return: "Retornar",
            view_result: "Ver resultado",
            test_time_limit: "Tempo limite do teste:",
            chrome: "Chrome",
            firefox: "Firefox",
            total_test_time: "Tempo total do teste:",
            time_notice: "Após iniciar, o tempo continuará correndo mesmo que você saia do teste.",
        },
        results: {
            selection_process: "Processo Seletivo",
            behavioral_profile_result: "Este resultado apresenta um retrato atual de seu perfil comportamental e não busca te definir como indivíduo.",
            unique_individual_statement: "Cada pessoa é única e ninguém cabe numa caixinha.",
            information_utility_message: "Esperamos que as informações mostradas aqui possam ser úteis para você. 😊",
            goals: "Objetivos",
            emotions: "Emoções",
            judges_others_based_on: "Julga os outros olhando para",
            methods_of_influencing_others: "Métodos de influenciar os outros",
            value_to_the_organization: "Valor para a organização",
            uses_excessively: "Usa excessivamente",
            under_pressure: "Sob pressão",
            avoids: "Evita",
            needs_to_develop: "Precisa desenvolver",

        },
        disc_card: {
            click_on_bars_to_read_description: "Clique nas barras para ler a descrição de cada fator",
            high_dominance: "Alta Dominância",
            assertive: "Assertivo",
            competitive: "Competitivo",
            high_self_esteem: "Elevada autoestima",
            direct: "Direto",
            objective: "Objetivo",
            positive_behaviors: "Comportamentos Positivos",
            adventurous: "Aventureiro",
            takes_initiative: "Toma iniciativa",
            bold: "Ousado",
            persistent: "Persistente",
            focuses_on_results: "Foca nos resultados",
            determined: "Determinado",
            limiting_behaviors: "Comportamentos Limitantes",
            takes_too_many_risks: "Arrisca demais",
            arrogant: "Arrogante",
            impulsive: "Impulsivo",
            insensitive: "Insensível",
            difficulty_in_delegating: "Dificuldade para delegar",
            takes_on_many_responsibilities: "Assume muitas responsabilidades",
            brings_value_to_the_team: "Traz valor para a equipe",
            coordinating: "Coordenando",
            innovating: "Inovando",
            with_proactivity: "Com proatividade",
            with_motivation_in_the_face_of_challenges: "Com motivação diante de desafios",
            the_ideal_environment_provides: "O ambiente ideal proporciona",
            debates_to_express_viewpoints: "Debates para expressar pontos de vista",
            freedom_to_make_decisions: "Liberdade para tomar decisões",
            challenges_and_opportunities: "Desafios e oportunidades",
            little_routine: "Pouca rotina",
            under_pressure_can_be: "Sob pressão pode ser",
            very_demanding: "Muito exigente",
            aggressive: "Agressivo",
            selfish: "Egoísta",
            low_dominance: "Baixa Dominância",
            conservative: "Conservador",
            moderate: "Moderado",
            diplomatic: "Diplomático",
            unpretentious: "Despretensioso",
            careful: "Cuidadoso",
            high_influence: "Alta Influência",
            confident: "Confiante",
            optimistic: "Otimista",
            persuasive: "Persuasivo",
            sociable: "Sociável",
            communicative: "Comunicativo",
            attentive: "Atencioso",
            charming: "Encantador",
            convincing: "Convincente",
            warm: "Caloroso",
            inspiring: "Inspirador",
            good_humored: "Bem-humorado",
            inattentive_to_details: "Desatento aos detalhes",
            loses_focus_easily: "Perde o foco com facilidade",
            disorganized: "Desorganizado",
            difficulty_completing_tasks: "Dificuldade em completar tarefas",
            difficulty_managing_time: "Dificuldade para gerir o tempo",
            speaks_without_thinking: "Fala sem pensar",
            resolving_conflicts_creatively: "Resolvendo conflitos com criatividade",
            motivating_others: "Motivando os demais",
            being_optimistic: "Sendo otimista",
            collaborating: "Colaborando",
            constant_contact_with_people: "Contato constante com as pessoas",
            space_to_hear_ideas: "Espaço para ouvir ideias",
            freedom_to_communicate: "Liberdade para se comunicar",
            democratic_managers: "Gestores democráticos",
            very_optimistic: "Muito otimista",
            not_very_realistic: "Pouco realista",
            talks_too_much: "Fala demais",
            low_influence: "Baixa Influência",
            serious: "Sério",
            skeptical: "Cético",
            reserved: "Reservado",
            reflective: "Reflexivo",
            rational: "Racional",
            high_stability: "Alta Estabilidade",
            good_listener: "Bom ouvinte",
            self_controlled: "Autocontrolado",
            patient: "Paciente",
            kind: "Amável",
            thoughtful: "Ponderado",
            friendly: "Amigável",
            peacemaker: "Apaziguador",
            calm: "Calmo",
            understanding: "Compreensivo",
            loyal: "Leal",
            sincere: "Sincero",
            avoids_conflicts: "Foge de conflitos",
            lacks_initiative: "Falta iniciativa",
            dislikes_change: "Não gosta de mudanças",
            inflexible: "Pouco flexível",
            difficulty_setting_priorities: "Dificuldade para estabelecer prioridades",
            low_ambition: "Pouca ambição",
            listening: "Ouvindo",
            serving: "Servindo",
            conveying_calm: "Transmitindo calma",
            bringing_consistency: "Trazendo consistência",
            stability: "Estabilidade",
            few_conflicts: "Poucos conflitos",
            lasting_work_relationships: "Relações de trabalho duradouras",
            predictability: "Previsibilidade",
            indecisive: "Indeciso",
            inflexible: "Inflexível",
            closed: "Fechado",
            low_stability: "Baixa Estabilidade",
            active: "Ativo",
            restless: "Inquieto",
            impetuous: "Impetuoso",
            energetic: "Enérgico",
            flexible: "Flexível",
            high_conformity: "Alta Conformidade",
            self_discipline: "Autodisciplinado",
            precise: "Preciso",
            detail_oriented: "Detalhista",
            prudent: "Precavido",
            perfectionist: "Perfeccionista",
            analytical: "Analítico",
            diplomatic: "Diplomático",
            seeks_achievements: "Busca realizações",
            asks_good_questions: "Faz boas perguntas",
            thinks_objectively: "Pensa objetivamente",
            low_conformity: "Baixa Conformidade",
            arrogant_when_challenged: "Arrogante quando contrariado",
            defensive_to_criticism: "Defensivo às críticas",
            inflexible: "Inflexível",
            very_critical: "Muito crítico",
            slow_to_act: "Lento para agir",
            seems_distant_and_cold: "Parece distante e frio",
            solves_problems_using_understanding: "Resolve problemas usando compreensão",
            aware_and_consistent: "Consciente e consistente",
            defines_and_clarifies: "Define e esclarece",
            gathers_information_and_tests_it: "Obtém informação e põe à prova",
            openness_to_critical_thinking: "Abertura para pensamentos críticos",
            close_relationships_with_small_groups: "Relações estreitas com pequenos grupos",
            privacy: "Privacidade",
            freedom_to_question: "Liberdade para questionar",
            hard_to_please: "Difícil de agradar",
            pessimistic: "Pessimista",
            excessively_meticulous: "Exageradamente meticuloso",
            firm: "Firme",
            independent: "Independente",

        },
        disc_factors_bar: {
            empathetic: "Empático",

        }
    },
    evaluation: {
        expired: {
            title: "Prazo Expirado",
            description:
            "Infelizmente o prazo para responder o teste já venceu",
        },
        form: {
            welcome: "Seja bem-vindo a sua avaliação.",
            instructions: "Clique em continuar para iniciar o seu teste",
            attention: "Atenção",
            forward_without_answering: "Deseja avançar sem responder?",
            not_possible_return: "Não será possível voltar nessa questão",
            "choose-a-quiet-and-well-lit-place":
                "Escolha um local tranquilo e bem iluminado",
            "if-possible-use-wifi-or-broadband-connection":
                "Se possível, use wifi ou banda larga",
            "so-you-can-focus-on-what-really-matter":
                "Assim você pode focar no que realmente importa",
            "this-way-you-avoid-problems-with-slowness-during-the-interview":
                "Assim você evita problemas com lentidão durante a entrevista",
            "got-it": "Entendi",
            start: "Começar",
            "video-interview": {
                "fail-system-requirements":
                    "Infelizmente o seu navegador não suporta este serviço",
                welcome: "Seja bem-vindo a sua avaliação.",
                instructions:
                    "Por favor, clique em continuar e siga as instruções.",
                hello_user: "Olá, {0}!",
                lets_try_again: "Começar novamente",
                warning_recording_again:
                    "O vídeo gravado anteriormente para a pergunta não foi salvo no sistema, por favor tente novamente",
                "time-to-response": "para resposta",
                minutes: "{0} min.",
                seconds: "{0} seg",
                "testing-your-camera-and-audio":
                    "Testando a sua câmera e microfone",
                "testing-your-camera-and-audio-description":
                    "Grave um vídeo curto de você falando para conferir sua imagem e aúdio.",
                "testing-your-camera": "Testando a sua câmera",
                "i-can-see-me-and-the-quality-is-good":
                    "Me vejo e a qualidade está boa.",
                "testing-your-audio": "Testando o seu áudio",
                "i-can-hear-me-and-the-quality-is-good":
                    "Me ouço e a qualidade está boa.",
                congratulations: "Parabéns {0}",
                "you-finished": "Você concluiu o questionário",
                "wait-return": "Aguarde o retorno do selecionador",
                "to-start": "para começar",
                "answer-now": "Responder agora",
                start: "Começar",
                continue: "Continuar",
                "ok-already-answered": "Pronto, já respondi",
                "all-working": "Tudo funcionando",
                "have-a-good-interview": "Tenha uma boa entrevista",
                question: "Questão",
                of: "de",
            },
            "browser-not-supported": "Navegador não suportado",
            "please-use-one-of-the-browsers-below":
                "Por favor, utilize um dos navegadores abaixo:",
        },
        evaluation_not_found: "Avaliação não encontrada",
        successfully_reseted: "Resetado com sucesso",
        evaluation_request_not_found: "Solicitação de avaliação não encontrada",
    },
    "test-alerts": {
        "test-cam": "Testar câmera",
        "test-cam-mic": "Testar câmera e microfone",
        "test-mic": "Testar microfone",
    },
    styleguide: {
        spinbutton: {
            field: {
                label: "Form Field Spinbutton",
                placeholder: "",
                description: "Use os campos abaixo para ajustar o componente",
            },
            step: {
                label: "Step",
                placeholder: "",
                description: "",
            },
            min: {
                label: "Min",
                placeholder: "",
                description: "",
            },
            max: {
                label: "Max",
                placeholder: "",
                description: "",
            },
        },
    },
    faq: {
        title: "Perguntas Frequentes",
        portal: {
            questions: [
                {
                    question: "Descubra como recuperar o seu login e senha caso não se lembre ou tenha perdido.",
                    answer: "Na página de login, clique em 'Esqueci minha senha'. Em seguida, insira seu CPF e clique em 'Criar nova senha'. Você receberá um e-mail cadastrado na plataforma com orientações para criar uma nova senha. Certifique-se de verificar também sua caixa de spam ou lixo eletrônico caso não encontre o e-mail na caixa de entrada."
                },
                {
                    question: "Descubra como recuperar o seu login e senha mesmo sem ter acesso ao seu e-mail.",
                    answer: "Na página de login, clique em 'Esqueci minha senha', insira seu CPF e clique em 'Criar nova senha'. Se não tiver acesso ao e-mail, clique em 'Não tenho mais acesso a este e-mail'. Em seguida, forneça seu CPF e número de telefone. Um código de confirmação será enviado para o seu telefone, permitindo que você troque sua senha normalmente."
                },
                {
                    question: "Quando cadastro meu currículo, o que acontece com os meus dados?",
                    answer: "Quando você realiza o seu cadastro e não se candidata em nenhuma vaga, seu currículo fica disponível em um banco de currículos, podendo ser convocado para oportunidades de trabalho. Caso você realize uma candidatura, além do seu currículo ficar disponível em um banco, o seu perfil será avaliado para a oportunidade desejada."
                },
                {
                    question: "Não quero mais receber os e-mails desta empresa. E agora?",
                    answer: "Poxa, que pena! Nossas comunicações visam ajudá-lo na recolocação profissional e na busca de oportunidades melhores. Caso não deseje recebê-las, vá até o e-mail recebido e clique na opção 'Se deseja não receber mais mensagens como esta, clique aqui' ou 'Cancelar inscrição'."
                },
                {
                    question: "Como o recrutador entra em contato comigo?",
                    answer: "A empresa que está conduzindo o seu processo seletivo tem liberdade para escolher a melhor forma de contatá-lo(a). Caso você tenha realizado a candidatura e ainda não tenha recebido nenhum contato por e-mail, telefone ou redes sociais, aguarde o retorno da empresa, pois o seu perfil ainda pode estar sendo avaliado. Caso já tenha o contato do recrutador, você pode questionar diretamente a empresa."
                },
                {
                    question: "Como funciona a política de privacidade?",
                    answer: "Ao se cadastrar, você aceita as Políticas de Privacidade da empresa contratante (se houver) e da plataforma Selecty. Na Política de Privacidade, explicamos detalhadamente como coletamos, utilizamos e protegemos seus dados. Coletamos essas informações para oferecer a melhor experiência de serviço possível, personalizar nosso atendimento e cumprir obrigações legais, sempre em conformidade com a LGPD (Lei Geral de Proteção de Dados). Para mais informações, acesse o link: <a href='https://selecty.com.br/politica-privacidade/' target='_blank'>Clique aqui</a>"
                },
                {
                    question: "Eu posso me candidatar para vagas diferentes da mesma empresa?",
                    answer: "Sim, é possível! Você pode participar de diversos processos seletivos ao mesmo tempo, mas cabe à empresa contratante determinar as regras que delimitam e regulam a participação de candidatos ativos em mais de um processo seletivo simultaneamente."
                },
                {
                    question: "Posso reaproveitar o cadastro do meu currículos em várias empresas?",
                    answer: "Sim, isso é possível com o login via Selecty.Jobs. Você cadastra o seu currículo uma vez e pode reutilizá-lo em todas as empresas com vagas disponíveis na plataforma Selecty."
                },
                {
                    question: "Como solicitar a exclusão dos meus dados?",
                    answer: "Após entrar na sua conta, acesse a aba 'Conta' e desça até a aba 'Privacidade de dados', em seguida, clique em 'exercer todos os direitos dos titulares' para abrir o Formulário de Requisição de Direitos do Titular de Dados Pessoais. Basta concluir o preenchimento do formulário e clicar em 'Finalizar' para completar a solicitação."
                },
                {
                    question: "Como acompanhar meus processos seletivos?",
                    answer: "Realize o login no portal e acesse a aba 'Minhas vagas' no menu lateral esquerdo. Lá, você poderá verificar o seu status em cada um dos processos seletivos aos quais se candidatou, bem como o status de cada vaga."
                },
                {
                    question: "Por que minha candidatura foi encerrada?",
                    answer: "Sua candidatura pode ter sido encerrada por diferentes motivos, como o encerramento ou cancelamento do processo seletivo, mudanças nos critérios de seleção da empresa, entre outros fatores. Caso tenha dúvidas, recomendamos que entre em contato diretamente com a empresa para obter mais detalhes sobre o encerramento."
                },
                {
                    question: "Ainda não recebi um retorno sobre meu processo seletivo.",
                    answer: "Os prazos de retorno podem variar de acordo com o processo seletivo e a empresa. Se o tempo informado já passou ou você está esperando há um período prolongado, recomendamos entrar em contato diretamente com a empresa para verificar o status da sua candidatura. Fique atento ao seu e-mail e à sua página de perfil no portal, onde atualizações sobre o processo podem ser enviadas."
                },
                {
                    question: "Já concluí a etapa mais recente do processo seletivo, mas ainda não liberaram a próxima.",
                    answer: "Se você já concluiu a etapa anterior e a próxima não foi liberada, pode ser necessário aguardar a análise do recrutador ou da equipe de seleção. Para obter mais informações sobre o status do seu processo, recomendamos entrar em contato diretamente com a empresa responsável pela seleção. Eles poderão fornecer detalhes sobre o andamento e se há alguma ação necessária da sua parte."
                },
                {
                    question: "Boas práticas para o envio de documentos admissionais.",
                    answer: "<p>Parabéns pela sua contratação! Sabemos que este é um momento emocionante e especial.</p><p>Agora, é hora de enviar seus documentos para completar a admissão, e gostaríamos de compartilhar algumas dicas importantes para garantir o sucesso do processo:</p><p>Os formatos permitidos para o envio de documentos são: JPG, JPEG, PNG e PDF.</p><p>Caso não tenha o documento solicitado em mãos, é recomendável aguardar até que esteja disponível e evitar o envio de outro documento que não corresponda. Por exemplo, não envie o protocolo de recebimento da CNH no lugar do documento original solicitado.</p><p>Não envie documentos vencidos. Se for um documento obrigatório (necessário para avançar no processo), entre em contato com a empresa responsável pelo processo seletivo para resolver a situação.</p><p>As imagens dos documentos devem estar em alta qualidade para evitar devoluções e atrasos no processo.</p><p>Preencha todos os campos do formulário de forma correta e precisa. Caso tenha dúvidas sobre o que preencher em algum campo, realize uma pesquisa ou consulte fontes confiáveis.</p><p>Envie todos os documentos dentro do prazo estipulado e aguarde a resposta da empresa. Eles estarão organizando tudo para garantir que sua admissão ocorra de acordo com a lei, o que pode levar algum tempo.</p><p>Para dúvidas específicas sobre a vaga ou sobre a aceitação de outros documentos, entre em contato diretamente com o recrutador ou a empresa contratante.</p>"
                },
                {
                    question: "Como alterar as preferências de cookies?",
                    answer: "<p>Os cookies desempenham um papel importante na navegação online, ajudando o site a oferecer experiências personalizadas e otimizadas. No entanto, é fundamental que você, como usuário, tenha controle sobre quais informações deseja compartilhar.</p><p>Nosso sistema utiliza um componente que exibe a janela de consentimento de cookies apenas quando detecta a necessidade de aprovação, como ao acessar pela primeira vez ou após a limpeza de cookies do navegador.</p><p>Se você deseja gerenciar os cookies de forma geral, as etapas variam de acordo com o navegador utilizado:</p><p>Para desktop:</p><p><strong>Google Chrome:</strong></p><ol><li>Clique no ícone de três pontos no canto superior direito.</li><li>Vá até Configurações > Privacidade e Segurança > Cookies e outros dados do site.</li><li>Ajuste as preferências conforme desejado.</li></ol><p><strong>Mozilla Firefox:</strong></p><ol><li>Acesse o menu (ícone de três linhas no canto superior direito).</li><li>Vá até Configurações > Privacidade e Segurança.</li><li>Em Cookies e dados do site, personalize as permissões.</li></ol><p><strong>Microsoft Edge:</strong></p><ol><li>Clique no ícone de três pontos no canto superior direito.</li><li>Vá até Configurações > Cookies e permissões do site.</li><li>Ajuste suas preferências.</li></ol><p><strong>Safari (macOS):</strong></p><ol><li>No menu superior, selecione Safari > Preferências > Privacidade.</li><li>Escolha gerenciar ou bloquear cookies.</li></ol><p>Para mobile:</p><p><strong>Google Chrome (Android e iOS):</strong></p><ol><li>Toque no ícone de três pontos no canto superior direito (Android) ou inferior direito (iOS).</li><li>Acesse Configurações > Privacidade e segurança > Configurações de sites > Cookies.</li><li>Ajuste as permissões conforme desejado.</li></ol><p><strong>Mozilla Firefox (Android e iOS):</strong></p><ol><li>Toque no menu (ícone de três linhas no canto inferior direito).</li><li>Vá para Configurações > Privacidade e segurança > Gerenciamento de cookies e dados do site.</li><li>Escolha como deseja gerenciar os cookies.</li></ol><p><strong>Safari (iOS):</strong></p><ol><li>Abra os Ajustes do dispositivo.</li><li>Role até Safari e selecione Privacidade e segurança.</li><li>Ative ou desative as configurações de cookies conforme sua preferência.</li></ol><p><strong>Microsoft Edge (Android e iOS):</strong></p><ol><li>Toque no ícone de três pontos no canto inferior direito.</li><li>Acesse Configurações > Permissões de site > Cookies.</li><li>Ajuste as configurações de cookies como preferir.</li></ol>No entanto, é fundamental que você, como usuário, tenha controle sobre quais informações deseja compartilhar.</p><p>Nosso sistema utiliza um componente que exibe a janela de consentimento de cookies apenas quando detecta a necessidade de aprovação, como ao acessar pela primeira vez ou após a limpeza de cookies do navegador.</p><p>Se você deseja gerenciar os cookies de forma geral, as etapas variam de acordo com o navegador utilizado:</p><p>Para desktop:</p><p><strong>Google Chrome:</strong></p><ol><li>Clique no ícone de três pontos no canto superior direito.</li><li>Vá até Configurações > Privacidade e Segurança > Cookies e outros dados do site.</li><li>Ajuste as preferências conforme desejado.</li></ol><p><strong>Mozilla Firefox:</strong></p><ol><li>Acesse o menu (ícone de três linhas no canto superior direito).</li><li>Vá até Configurações > Privacidade e Segurança.</li><li>Em Cookies e dados do site, personalize as permissões.</li></ol><p><strong>Microsoft Edge:</strong></p><ol><li>Clique no ícone de três pontos no canto superior direito.</li><li>Vá até Configurações > Cookies e permissões do site.</li><li>Ajuste suas preferências.</li></ol><p><strong>Safari (macOS):</strong></p><ol><li>No menu superior, selecione Safari > Preferências > Privacidade.</li><li>Escolha gerenciar ou bloquear cookies.</li></ol><p>Para mobile:</p><p><strong>Google Chrome (Android e iOS):</strong></p><ol><li>Toque no ícone de três pontos no canto superior direito (Android) ou inferior direito (iOS).</li><li>Acesse Configurações > Privacidade e segurança > Configurações de sites > Cookies.</li><li>Ajuste as permissões conforme desejado.</li></ol><p><strong>Mozilla Firefox (Android e iOS):</strong></p><ol><li>Toque no menu (ícone de três linhas no canto inferior direito).</li><li>Vá para Configurações > Privacidade e segurança > Gerenciamento de cookies e dados do site.</li><li>Escolha como deseja gerenciar os cookies.</li></ol><p><strong>Safari (iOS):</strong></p><ol><li>Abra os Ajustes do dispositivo.</li><li>Role até Safari e selecione Privacidade e segurança.</li><li>Ative ou desative as configurações de cookies conforme sua preferência.</li></ol><p><strong>Microsoft Edge (Android e iOS):</strong></p><ol><li>Toque no ícone de três pontos no canto inferior direito.</li><li>Acesse Configurações > Permissões de site > Cookies.</li><li>Ajuste as configurações de cookies como preferir.</li></ol>"
                }
            ],
        },
        sj: {
            questions: [
                {
                    question: "Descubra como recuperar o seu login e senha caso não se lembre ou tenha perdido.",
                    answer: `Na página de login, clique em "Esqueci minha senha". Em seguida, insira seu CPF e clique em "Criar nova senha". Você receberá um e-mail cadastrado na plataforma com orientações para criar uma nova senha. Certifique-se de verificar também sua caixa de spam ou lixo eletrônico caso não encontre o e-mail na caixa de entrada.`,
                },
                {
                    question: "Descubra como recuperar o seu login e senha mesmo sem ter acesso ao seu e-mail.",
                    answer: `Na página de login, clique em "Esqueci minha senha", insira seu CPF e clique em "Criar nova senha". Se não tiver acesso ao e-mail, clique em "Não tenho mais acesso a este e-mail". Em seguida, forneça seu CPF e número de telefone. Um código de confirmação será enviado para o seu telefone, permitindo que você troque sua senha normalmente.`,
                },
                {
                    question: "O que é o Selecty.Jobs?",
                    answer: "Para o candidato, o Selecty.Jobs é um marketplace de tecnologia que conecta empresas e profissionais. Aqui, você encontrará milhares de oportunidades de trabalho e poderá, gratuitamente, cadastrar seu currículo e se candidatar às vagas do seu interesse.",
                },
                {
                    question: "Quando cadastro meu currículo, o que acontece com os meus dados?",
                    answer: "Quando você realiza o seu cadastro e não se candidata em nenhuma vaga, seu currículo fica disponível para empresas contratantes, podendo ser convocado para oportunidades de trabalho. Caso você realize uma candidatura, além do seu currículo ficar disponível para empresas contratantes, o seu perfil será avaliado para a oportunidade desejada.",
                },
                {
                    question: "Não quero mais receber os e-mails do Selecty.Jobs. E agora?",
                    answer: `Poxa, que pena! Nossas comunicações visam ajudá-lo na recolocação profissional e na busca de oportunidades melhores, mas caso não deseje recebê-las, vá até o e-mail recebido e clique na opção "Se deseja não receber mais mensagens como esta, clique aqui" ou "Cancelar inscrição".`,
                },
                {
                    question: "Quando conseguir um emprego pelo Selecty.Jobs precisarei pagar alguma taxa?",
                    answer: "Não. O Selecty.Jobs não cobra quisquer valores de candidatos.",
                },
                {
                    question: "Como o recrutador entra em contato comigo?",
                    answer: "A empresa que está conduzindo o seu processo seletivo tem liberdade para escolher a melhor forma de contatá-lo(a). Caso você tenha realizado a candidatura e ainda não tenha recebido nenhum contato por e-mail, telefone ou redes sociais, aguarde o retorno da empresa, pois o seu perfil ainda pode estar sendo avaliado. Caso já tenha o contato do recrutador, você pode questionar diretamente a empresa.",
                },
                {
                    question: "Como funciona a política de privacidade?",
                    answer: "Na Política de Privacidade, explicamos detalhadamente como coletamos, utilizamos e protegemos seus dados. Coletamos essas informações para oferecer a melhor experiência de serviço possível, personalizar nosso atendimento e cumprir obrigações legais, sempre em conformidade com a LGPD (Lei Geral de Proteção de Dados). Para mais informações, <a href='https://selecty.com.br/politica-privacidade/' target='_blank'>Clique aqui</a>.",
                },
                {
                    question: "Eu posso me candidatar para vagas diferentes da mesma empresa?",
                    answer: "Sim, é possível! Você pode participar de diversos processos seletivos ao mesmo tempo, mas cabe à empresa contratante determinar as regras que delimitam e regulam a participação de candidatos ativos em mais de um processo seletivo simultaneamente.",
                },
                {
                    question: "Posso reaproveitar o cadastro do meu currículos em várias empresas?",
                    answer: "Sim. No Selecty.Jobs você cadastra o currículo uma vez e pode reutilizá-lo em todas as empresas com vagas disponíveis na plataforma.",
                },
                {
                    question: "Como solicitação a exclusão dos meus dados?",
                    answer: `Após entrar na sua conta, acesse a aba "Conta" e desça até a aba "Privacidade de dados", em seguida, clique em "exercer todos os direitos dos titulares" para abrir o Formulário de Requisição de Direitos do Titular de Dados Pessoais. Basta concluir o preenchimento do formulário e clicar em "Finalizar" para completar a solicitação.`,
                },
                {
                    question: "Como acompanhar meus processos seletivos?",
                    answer: "Realize o login pelo <a href='https://selecty.jobs/login' target='_blank'>link</a> e acesse a aba 'Minhas vagas' no menu lateral esquerdo. Lá, você poderá verificar o seu status em cada um dos processos seletivos aos quais se candidatou, bem como o status de cada vaga.",
                },
                {
                    question: "Por que minha candidatura foi encerrada?",
                    answer: "Sua candidatura pode ter sido encerrada por diferentes motivos, como o encerramento ou cancelamento do processo seletivo, mudanças nos critérios de seleção da empresa, entre outros fatores. Caso tenha dúvidas, recomendamos que entre em contato diretamente com a empresa para obter mais detalhes sobre o encerramento.",
                },
                {
                    question: "Ainda não recebi um retorno sobre meu processo seletivo.",
                    answer: "Os prazos de retorno podem variar de acordo com o processo seletivo e a empresa. Se o tempo informado já passou ou você está esperando há um período prolongado, recomendamos entrar em contato diretamente com a empresa para verificar o status da sua candidatura. Fique atento ao seu e-mail e à sua página de perfil no portal, onde atualizações sobre o processo podem ser enviadas.",
                },
                {
                    question: "Já concluí a etapa mais recente do processo seletivo, mas ainda não liberaram a próxima.",
                    answer: "Se você já concluiu a etapa anterior e a próxima não foi liberada, pode ser necessário aguardar a análise do recrutador ou da equipe de seleção. Para obter mais informações sobre o status do seu processo, recomendamos entrar em contato diretamente com a empresa responsável pela seleção. Eles poderão fornecer detalhes sobre o andamento e se há alguma ação necessária da sua parte.",
                },
                {
                    question: "Boas práticas para o envio de documentos admissionais.",
                    answer: "<p>Parabéns pela sua contratação! Sabemos que este é um momento emocionante e especial.</p><p>Agora, é hora de enviar seus documentos para completar a admissão, e gostaríamos de compartilhar algumas dicas importantes para garantir o sucesso do processo:</p><p><strong>Os formatos permitidos para o envio de documentos são:</strong> JPG, JPEG, PNG e PDF.</p><p>Caso não tenha o documento solicitado em mãos, é recomendável aguardar até que esteja disponível e evitar o envio de outro documento que não corresponda. Por exemplo, não envie o protocolo de recebimento da CNH no lugar do documento original solicitado.</p><p>Não envie documentos vencidos. Se for um documento obrigatório (necessário para avançar no processo), entre em contato com a empresa responsável pelo processo seletivo para resolver a situação.</p><p>As imagens dos documentos devem estar em alta qualidade para evitar devoluções e atrasos no processo.</p><p>Preencha todos os campos do formulário de forma correta e precisa. Caso tenha dúvidas sobre o que preencher em algum campo, realize uma pesquisa ou consulte fontes confiáveis.</p><p>Envie todos os documentos dentro do prazo estipulado e aguarde a resposta da empresa. Eles estarão organizando tudo para garantir que sua admissão ocorra de acordo com a lei, o que pode levar algum tempo.</p><p>Para dúvidas específicas sobre a vaga ou sobre a aceitação de outros documentos, entre em contato diretamente com o recrutador ou a empresa contratante.</p>",
                },
                {
                    question:
                        "Como fazer uma boa imagem para enviar os documentos para a empresa",
                    answer: "<p>Parabéns pela sua admissão! Chegou a hora de enviar seus documentos para que o processo seja completo.</p><p>Tirar fotos de documentos parece algo muito simples, especialmente quando temos um celular. Selecionamos abaixo algumas dicas que podem tornar a experiência da sua admissão mais ágil e assertiva na hora de enviar imagens para serem validadas:</p><ul class='mx-3'><li>Procure um local claro e iluminado, seja natural ou artificialmente (com lâmpadas), para capturar as imagens dos seus documentos;</li><li>Aumente ao máximo a luminosidade visual do seu celular (aquela que ilumina a tela);</li><li>Desamasse ou insista para diminuir dobras ou voltas, tornando o documento bem liso;</li><li>Coloque o documento sobre uma mesa ou superfície plana e firme. Caso tenha um fundo escuro, ele pode ser colocado atrás do documento a ser fotografado, o que ajudará na boa qualidade da imagem</li><li>É importante enquadrar todo o documento na tela, sem deixar nenhuma borda de fora;</li><li>Atente para as sombras que podem se formar ao fazer a captura da imagem;</li><li>Tire a foto exatamente acima, no mesmo ângulo da superfície (o documento deve formar um retângulo perfeito, sem permitir que a parte superior fique menor que a inferior ou que haja diferenças de tamanho nas laterais);</li><li>Após a captura com o próprio aplicativo de fotos, acerte as bordas, recortando as laterais que não pertencem ao documento (que são do fundo atrás dele);</li></ul><p>Confirme a visibilidade respondendo sim a estas perguntas. Se alguma delas for respondida com não, por favor, repita o processo:</p><ol class='mx-3'><li>O documento aparece em sua totalidade? Aparecem todos os lados sem cortes?</li><li>O foco ficou adequado? Consigo ler tudo sem que as letras e números estejam embaçados?</li><li>É possível ver com clareza todas as informações do documento? Ele está adequado na questão da luminosidade (nem claro nem escuro demais)?</li></ol><p>Você também pode utilizar aplicativos para realizar o escaneamento da imagem pelo celular ou uma impressora que digitaliza a imagem com qualidade. É importante lembrar que o sistema só aceita o envio de documentos com a terminação jpg, jpeg, png, e pdf.</p><p>Tenha uma boa sessão de fotos!</p>",
                },
                {
                    question: "Como funciona a admissão online?",
                    answer: "A admissão online facilita e agiliza o processo de contratação, permitindo que todo o trâmite seja feito de forma digital. O candidato cadastra suas informações pessoais e profissionais diretamente na plataforma e envia os documentos necessários para a empresa, de maneira rápida e segura. A empresa ainda pode solicitar etapas presenciais, como o exame médico admissional, por exemplo.",
                },
                {
                    question: "Quais serão os documentos solicitados no processo de admissão?",
                    answer: "<p>Os documentos exigidos em uma admissão variam de acordo com a legislação trabalhista e as políticas internas de cada empresa, mas alguns documentos são geralmente solicitados em quase todos os processos de admissão. No Brasil, por exemplo, os documentos mais comuns incluem:</p><ul><li><strong>Carteira de Trabalho e Previdência Social (CTPS)</strong><br>Documento obrigatório para formalizar o vínculo empregatício.</li><li><strong>Documento de Identidade (RG)</strong><br>Serve para comprovar a identidade do colaborador.</li><li><strong>Cadastro de Pessoa Física (CPF)</strong><br>Documento que identifica o trabalhador perante a Receita Federal.</li><li><strong>Título de Eleitor</strong><br>Comprovante de quitação eleitoral pode ser solicitado.</li><li><strong>Comprovante de Residência</strong><br>Para verificar o endereço atual do colaborador.</li><li><strong>Certificado de Reservista (para homens)</strong><br>Comprova a quitação com o serviço militar obrigatório, quando aplicável.</li><li><strong>Carteira Nacional de Habilitação (CNH)</strong><br>Caso o cargo exija habilitação, como no caso de motoristas.</li><li><strong>Certidão de Nascimento ou Casamento</strong><br>Para registro do estado civil.</li><li><strong>Comprovante de Escolaridade</strong><br>Certificados ou diplomas que comprovem o nível de educação exigido para a vaga.</li><li><strong>PIS/PASEP</strong><br>Caso o trabalhador já tenha o cadastro, é necessário informar o número.</li><li><strong>Atestado Médico Admissional</strong><br>Documento emitido após exames médicos admissionais, para comprovar a aptidão do colaborador para o trabalho.</li><li><strong>Foto 3x4</strong><br>Algumas empresas ainda solicitam foto para compor o arquivo pessoal.</li><li><strong>Comprovante de Situação Cadastral no CPF</strong><br>Para confirmar que o CPF está regular junto à Receita Federal.</li><li><strong>Declaração de Dependentes para o Imposto de Renda</strong><br>Documento utilizado para fins de dedução de IR e cálculo de benefícios.</li><li><strong>Carteira de Vacinação (alguns setores)</strong><br>Algumas empresas exigem comprovantes de vacinas, especialmente em setores de saúde.</li></ul><p>Esses são os documentos básicos, mas algumas empresas podem solicitar documentos adicionais dependendo da função ou do setor de atuação.</p>",
                },
                {
                    question:
                        "E-mails da plataforma direcionados para Spam ou Lixo Eletrônico",
                    answer: "<p>Ao participar de um processo seletivo pelo Selecty.Jobs, normalmente o principal canal de comunicação entre a empresa contratante e você, é o e-mail. Por isso, é importante que você cheque seu e-mail regularmente, inclusive a caixa de SPAM.</p><p>Alguns provedores de e-mail podem marcar as mensagens enviadas pela plataforma como suspeitas, endereçando-as para pastas de SPAM ou lixo eletrônico e fazendo com que você perca alguma comunicação importante sobre o andamento do processo seletivo.</p><p>Além de checar as caixas de SPAM, você pode evitar que isso aconteça, é necessário marcar os nossos e-mails como confiáveis ou definir o domínio @selecty.com.br como confiável, caso seu provedor dê essa opção. Veja como fazer:</p><p class='mb-0'>Se o seu e-mail for do provedor Google:</p><a href='https://support.google.com/mail/answer/1366858?hl=pt-PT&authuser=1&expand=5' target='_blank'>Marcar ou desmarcar como spam no Gmail;</a><p class='mb-0 mt-3'>Caso o provedor seja Microsoft Outlook (Hotmail e Outlook):</p><a href='https://support.microsoft.com/pt-br/topic/filtrar-lixo-eletr%C3%B4nico-e-spam-no-outlook-db786e79-54e2-40cc-904f-d89d57b7f41d' target='_blank'>Filtrar lixo eletrônico e spam no Outlook na Web</a><p class='mb-0 mt-3'>Para domínio BOL e UOL:</p><a href='https://email.bol.uol.com.br/paginas-de-ajuda/sobre/configuracoes/antispam/como-funciona-o-antispam-do-seu-bol-mail.jhtm' target='_blank'>Como funciona o AntiSpam do seu BOL Mail</a><br><a href='https://email.uol.com.br/paginas-de-ajuda/sobre/configuracoes/antispam/configuracoes-antispam.jhtm' target='_blank'>Como funciona o Antispam UOL</a><p class='mb-0 mt-3'>Domínio Icloud:</p><a href='https://support.apple.com/pt-br/102376' target='_blank'>Marcar e-mails legítimos como não indesejados</a><p class='mb-0 mt-3'>Domínio Yahoo:</p><a href='https://br.ajuda.yahoo.com/kb/SLN28056.html?guccounter=2&guce_referrer=aHR0cHM6Ly9zdXBwb3J0LWNhbmRpZGF0ZXMuZ3VweS5pby8&guce_referrer_sig=AQAAAMRxkZHhZ4rJ_K3evwpoib9jAY5V1IAtFuLCfcj0BHdyL6iYyweDFc0WfvinTUyEcVYlHiahKX3z-Ka0E78bR6-thiKnX20UJ6DWYLVmfr-LKmHGdkG4T4m5NK0AUWBoAH2ru8XpLcbrR_OqNVzFvpaEwdVaMEm56S0nL3hl80b8' target='_blank'>Como gerenciar spam e listas de distribuição no Yahoo Mail</a><p class='mt-3'>Se o seu e-mail tem outro domínio que não foi listado acima, recomendamos que você acesse a Central de Ajuda do mesmo para entender como realizar a marcação de e-mails como confiáveis ou realizar a remoção da caixa de Spam.</p>",
                },
                {
                    question: "Termos e Condições de uso",
                    answer: "<a href='https://selecty.com.br/termos-de-uso/' target='_blank'>Clique aqui</a> para saber mais.",
                },
            ],
        },
    },
    terms_of_use: {
        companies: {
            title: "Termos de Uso para Empresas",
            subtitle: "Serviço: JobPost - Publicação Gratuita de Vagas",
            content: `
                <h5>1. Registro de Empresas, Perfil Público e Uso de Conta </h5>
                <p>1.1. O cadastro da empresa no portal {portal_url} ("Portal") implica a obrigatoriedade de fornecer informações empresariais e dados pessoais dos representantes da empresa, incluindo nome, e-mail e telefone. Após a validação do cadastro, a empresa poderá acessar os serviços disponibilizados pelo Selecty.</p>
                <p>1.2. O serviço JobPost é destinado exclusivamente para a divulgação de vagas de emprego da própria empresa cadastrada, atuando na condição de "empregador direto". Não é permitido o uso do serviço para a divulgação de vagas de terceiros ou para qualquer modalidade de trabalho que não seja destinada ao preenchimento do seu quadro próprio de funcionários.</p>
                <p>1.3. A Selecty reserva-se o direito de recusar o cadastro de empresas a seu exclusivo critério, incluindo, mas não se limitando a, razões de ordem comercial, violações anteriores aos Termos de Uso ou denúncias de atividades consideradas inadequadas.</p>
                <p>1.4. Apenas empresas devidamente constituídas e em situação regular podem realizar o cadastro, sendo que cada filial deve manter seu próprio registro de acesso. É expressamente proibido revender, compartilhar o acesso à conta, ou utilizar o Portal para finalidades distintas da publicação de ofertas de emprego.</p>
                <p>1.5. A empresa cadastrada terá um perfil público para divulgação de informações como logotipos e benefícios oferecidos aos funcionários. O registro e a publicação de vagas são gratuitos para a maioria das empresas, porém algumas poderão ser obrigadas a adquirir planos de serviços remunerados para usufruir de determinados recursos.</p>
                <p>1.6. A Selecty poderá fornecer informações sobre a empresa cadastrada às autoridades competentes, caso seja legalmente exigido.</p>
                <h5>2. Regras de Publicação de Vagas</h5>
                <p>2.1. As vagas publicadas devem estar em conformidade com a legislação vigente e não podem conter termos inapropriados, ofertas inadequadas, incitação ao ódio, discriminação ou qualquer conteúdo ilícito. A responsabilidade pelo conteúdo das vagas é integralmente da empresa que as publica, podendo a mesma desativar suas ofertas a qualquer momento.</p>
                <p>2.2. A Selecty reserva-se o direito de bloquear, suspender ou cancelar o cadastro de empresas que utilizem o Portal para a publicação de vagas de maneira abusiva ou em desacordo com estes Termos de Uso.</p>
                <h5>3. Gratuidade e Valores</h5>
                <p>3.1. O serviço JobPost é fornecido de forma gratuita, compreendendo as funcionalidades de: (a) divulgação da vaga no Portal {portal_url} e (b) recebimento dos currículos dos profissionais que se candidatarem à vaga.</p>
                <p>3.2. Caso a empresa deseje acessar recursos adicionais ou funcionalidades premium na plataforma, poderá optar pela contratação de planos remunerados, conforme descrito nos pacotes oferecidos pelo Selecty.</p>
                <h5>4. Vigência das Vagas e Renovação</h5>
                <p>4.1. As vagas publicadas terão vigência máxima de 90 (noventa) dias. Após este período, a Selecty poderá, a seu critério, desativar automaticamente a vaga, sendo facultado à empresa o direito de renovação da publicação caso a posição ainda não tenha sido preenchida.</p>
                <h5>5. Conteúdo das Vagas e Responsabilidade</h5>
                <p>.5.1. A Selecty poderá, a seu exclusivo critério, auditar e revisar o conteúdo das vagas publicadas periodicamente, no entanto, não assume qualquer responsabilidade pelo conteúdo veiculado pela empresa. Vagas consideradas duplicadas, irreais, ou que infrinjam a legislação em vigor, serão removidas do Portal.</p>
                <h5>6. Vagas para Menor Aprendiz</h5>
                <p>6.1. A empresa é responsável por observar e cumprir todas as regras e diretrizes específicas para a contratação de menores aprendizes, incluindo requisitos de idade e jornada de trabalho.</p>
                <h5>7. Recebimento de Candidaturas</h5>
                <p>7.1. A publicação de vagas no Portal {portal_url} permitirá que candidatos se inscrevam e disponibilizem seus currículos para visualização pela empresa. A partir desse momento, a empresa assume total responsabilidade pela comunicação, relacionamento e tratativas com os profissionais candidatos.</p>
                <p>7.2. A Selecty não se responsabiliza pelas informações fornecidas pelos profissionais, nem pela compatibilidade dos currículos com a vaga ofertada, tampouco pelo volume de candidaturas recebidas.</p>
                <h5>8. Proteção de Dados</h5>
                <p>8.1. As empresas se comprometem a tratar os dados dos candidatos com confidencialidade, utilizando tais informações exclusivamente para os processos seletivos relacionados à vaga publicada. A criação de bases de dados privadas ou a utilização dessas informações para finalidades diversas é expressamente proibida.</p>
                <p>8.2. A empresa declara expressamente que está em conformidade com as diretrizes e princípios estabelecidos pela Lei Geral de Proteção de Dados (Lei nº 13.709/2018 - LGPD) e que possui estrutura adequada para atender às requisições dos titulares de dados pessoais, bem como para prestar contas sobre os tratamentos realizados.</p>
                <h5>9. Denúncias e Penalidades</h5>
                <p>9.1. Em caso de irregularidades ou violação destes Termos de Uso, a Selecty poderá suspender ou encerrar o cadastro da empresa, sem que haja direito a reembolso ou indenização.</p>
                <h5>10. Rescisão e Cancelamento dos Serviços</h5>
                <p>10.1. A Selecty reserva-se o direito de cancelar a prestação dos serviços a qualquer momento, sem necessidade de aviso prévio, em caso de violação destes Termos de Uso ou de qualquer disposição legal.</p>
            `,
        },
        candidates: {
            sj: {
                title: "TERMOS E CONDIÇÕES GERAIS DE UTILIZAÇÃO DO SERVIÇO",
                content: `
                    <p>Os termos e condições abaixo se aplicam aos benefícios e serviços disponibilizados pela empresa SELECTY TECNOLOGIA PARA RH LTDA, pessoa jurídica de direito privado, com sede à Rua Professor Pedro Viriato Parigot de Souza, n° 3.901 – sala 38 – Cidade Industrial, no Município de Curitiba, Estado do Paraná, CEP 81.280-330, inscrita no CNPJ/MF sob o nº 09.236.362/0001-50, doravante designada SELECTY, para procedimento de cadastramento eletrônico, podendo ser realizado por qualquer pessoa física ou jurídica, doravante designado como USUÁRIO, incluindo o cadastramento e manutenção do de seu currículo neste software.</p>
                    <h5>Cláusula primeira: DAS CONSIDERAÇÕES GERAIS</h5>
                    <p>Aceitando os termos, você concorda em ficar vinculado aos seguintes termos e condições (TERMOS E CONDIÇÕES GERAIS DE UTILIZAÇÃO DO SERVIÇO). Se você está contratando representando uma pessoa jurídica, você declara que você tem a poderes de representação legal, bem como poderes para representar todos os usuários que utilizam os serviços de acesso através de sua conta com estes termos e condições, qualquer pessoa física, pessoa jurídica (sua matriz e suas filiais), bem como seus usuários autorizados. Se você não tiver tal autoridade/poderes, ou se você não concordar com os termos e condições, deverá assinalar o campo “li e não aceito os TERMOS E CONDIÇÕES GERAIS DE UTILIZAÇÃO DO SERVIÇO”.</p>
                    <p>Ao concordar com o presente instrumento, preenchendo o “LI e ACEITO os TERMOS E CONDIÇÕES GERAIS DE UTILIZAÇÃO DO SERVIÇO” após completar o processo de cadastramento, a anuência com o presente contrato é AUTOMÀTICA, o USUÁRIO manifesta sua plena anuência para conseguir avançar.</p>
                    <p>O USUÁRIO, assim entendido como pessoa maior de 18 (dezoito) anos de idade ou menor devidamente representado por seu(s) responsável(is) que acessa o sistema SELECTY a fim de cadastrar e manter seus dados curriculares no sistema, declara que aceita os termos e condições constantes deste termo, aderindo ao processo de cadastramento disponibilizado pela SELECTY.</p>
                    <h5>Cláusula segunda: DA DESCRIÇÃO DOS PRODUTOS E SERVIÇOS – DO OBJETO DO CONTRATO</h5>
                    <p>O objeto deste contrato é o uso pelo USUÁRIO dos serviços prestados pela SELECTY, consistente em:</p>
                    <p>Cadastramento, hospedagem, exposição e divulgação do Currículo cadastrado pelo USUÁRIO no SOFTWARE, que será disponibilizado para as empresas que estejam interessadas em alocar recursos humanos para determinada área/segmento do mercado; envio e recebimento de mensagens eletrônicas (e-mail); indicação de novos usuários e o aproveitamento de benefícios advindos. A função social do SOFTWARE é auxiliar o USUÁRIO a buscar seus objetivos no mercado de trabalho.</p>
                    <h5>Cláusula terceira: DAS OBRIGAÇÕES DO USUÁRIO / CONDIÇÕES DE USO</h5>
                    <p>O USUÁRIO obriga-se a não utilizar os serviços prestados pela SELECTY para: Fins ilegais ou para transmitir ou obter material em desacordo com a legislação brasileira; Transmitir/divulgar material ilegal, difamatório, que viole a privacidade de terceiros, ou que seja abusivo, ameaçador, obsceno, prejudicial, injurioso, calunioso; Enviar/divulgar quaisquer tipos de vírus ou arquivos contendo quaisquer tipos de vírus ou que possam causar danos ao seu destinatário ou terceiros; Obter ou tentar obter acesso não autorizado a outros sistemas ou redes de computadores conectados ao Serviço; Criar uma falsa identidade, inclusive utilizando, sem autorização, CPF e outros documentos de terceiros; O USUÁRIO compromete-se, ainda, a nunca inserir seu nome, endereço, telefone, fax, e-mail ou qualquer outro dado de contato, fora dos campos especificados para tanto. Na hipótese de a SELECTY constatar que o USUÁRIO descumpriu qualquer das obrigações estabelecidas neste termo de uso, fica assegurado o direito da SELECTY de SUSPENDER ou EXCLUIR a divulgação e os dados do USUÁRIO, ou, até mesmo, rescindir imediatamente o presente contrato, independente de qualquer ato premonitório. O USUÁRIO é o único responsável pelo conteúdo das transmissões feitas através do serviço, a partir de sua senha ou conta. O USUÁRIO é também o responsável pelos equipamentos necessários para sua conexão à Internet (computador, linha telefônica, modem e programas de computadores para acesso) e pelos custos de conexão.</p>
                    <p>É vedado ao USUÁRIO modificar, copiar, distribuir, transmitir, exibir, realizar, reproduzir, publicar, disponibilizar, licenciar ou criar perfis ou currículos derivados de informações de terceiros, não próprias, sob pena de violação do presente termo e infração legal. É vedado o USUÁRIO criar perfis falsos (FAKES).</p>
                    <p>A menos que tenha sido expressamente autorizado por escrito pela SELECTY a fazê-lo, o USUÁRIO concorda que, ao usar Sistema/SOFTWARE, não irá utilizar qualquer marca comercial, marca de serviço, marca registrada, logotipo de qualquer empresa ou organização, bem como que não irá cadastrar ou inserir no Sistema/SOFTWARE qualquer informação confidencial, texto ou imagem que seja de titularidade de terceiros, permanecendo exclusivamente responsável e isentando a SELECTY de qualquer responsabilidade quanto à violação da propriedade intelectual (VER POLÍTICA DE PRIVACIDADE) de terceiros que o USUÁRIO venha a cometer por meio de tais atos. Nesta hipótese, poderá SELECTY, independentemente de prévia notificação formal, excluir qualquer tipo de material, arquivado pelo USUÁRIO, que afronte a propriedade intelectual de terceiros, inclusive podendo excluir o USUÁRIO definitivamente do sistema.</p>
                    <p>Com base no princípio da autonomia da vontade, quaisquer das partes do insertas no presente instrumento, a qualquer momento, poderá resilir o presente instrumento imotivadamente, sem que este ato gere direito a qualquer tipo de indenização a outra parte, de qualquer natureza, devendo, neste caso, encaminhar e-mail ou qualquer outra forma de comunicação para a outra parte, com antecedência de 10 (dez) dias, informando sobre a rescisão, a qual operar-se-á automaticamente findo este prazo. A rescisão não implicará renúncia a eventuais perdas e danos que alguma parte tenha causado a outra durante a execução deste contrato.</p>
                    <p>O USUÁRIO será o único, direto e exclusivo responsável por todos os danos, infrações, descumprimento legais e atos de qualquer natureza, que venha a causar a terceiros ou outros quando da utilização do sistema objeto deste instrumento. Na hipótese da SELECTY vir a ser demandada em juízo por dano ocasionado pelo USUÁRIO, ser-lhe-á lícito alegar sua ilegitimidade passiva, nomeá-lo à autoria, denunciá-lo à lide etc., e praticar todos os atos necessários para exercer seu direito de defesa e eventual regresso, servindo o presente instrumento como título executivo extrajudicial de todos e quaisquer valores eventualmente despendidos pela SELECTY para fazer frente a indenizações, despesas judiciais etc., sendo que estes deverão ser atualizados na forma da lei, bem como será aplicada cláusula penal de 10% (dez por cento) sobre o seu total do débito.</p>
                    <p>O USUÁRIO reconhece que o conteúdo inserido no banco de dados da SELECTY, incluindo, mas não se limitando a texto, músicas, vídeo, sons, banco de dados e outros materiais contidos em outras propagandas disponíveis no serviço, bem como as informações divulgadas ao USUÁRIO através do serviço ou de anunciantes, podem estar protegidos por direitos autorais, marcas, patentes ou outros direitos de propriedade intelectual. (VER POLÍTICA DE PRIVACIDADE) O USUÁRIO fica ciente que poderá utilizar as informações e materiais apenas na hipótese de autorização da SELECTY ou pelas pessoas físicas e jurídicas anunciantes. O USUÁRIO Não poderá copiar, reproduzir, transmitir , distribuir ou recriar de maneira derivada com o conteúdo já disposto, sem a autorização expressa do titular do direito de propriedade.</p>
                    <p>A violação de quaisquer dos termos abaixo irá resultar no cancelamento de sua conta. O USUÁRIO fica ciente que a SELECTY não pode ser responsabilizada pelo conteúdo postado no SOFTWARE e você poderá ser exposto a tais materiais. O USUÁRIO concorda em usar o SOFTWARE por sua própria conta e risco.</p>
                    <h5>Cláusula quarta: DAS RESPONSABILIDADES DA SELECTY</h5>
                    <p>Para todos os fins de Direito, a SELECTY esclarece e informa ao USUÁRIO que todos os seus dados curriculares e informações pessoais, inseridas mediante acesso da página eletrônica da SELECTY, serão consultados a qualquer momento por outras empresas que utilizarem os sistemas informatizados disponibilizados por SELECTY TECNOLOGIA PARA RH LTDA, os quais funcionam como base de pesquisa e triagem de candidatos e processos seletivos. Neste sentido, os dados serão arquivados nos sistemas disponibilizados por esta última, a qual poderá divulgá-los a outras empresas. A SELECTY informa desde já que irá revelar os dados pessoais do USUÁRIO ao Estado e às Autoridades Públicas sem a permissão prévia do USUÁRIO apenas quando for legalmente requerida para tanto.</p>
                    <p>A SELECTY poderá, a qualquer tempo, retificar os termos do presente contrato na hipótese de necessidade de adequação, atualizando ou alterando, se comprometendo a disponibilizar nova cópia aos seus usuários, informando no SOFTWARE a existência da nova versão do contrato e solicitando a anuência expressa.</p>
                    <p>A SELECTY buscará manter o sistema ou o SOFTWARE acessível de maneira ininterrupta todos os dias (24h x 7 dias semanais) isenta de erros do sistema. O USUÁRIO fica ciente que a SELECTY não poderá se responsabilizar pela impossibilidade de submissão de dados no sistema por impossibilidade de acesso ou falha de comunicação do sistema do SOFTWARE ou por outros motivos alheiros.</p>
                    <p>A SELECTY não possui qualquer responsabilidade do USUÁRIO com a colocação ou recolocação do mesmo no mercado de trabalho, tampouco pelas consequências advindas com a posição do USUÁRIO no mercado de trabalho que ocorreram por intermédio do SOFTWARE.</p>
                    <p>A SELECTY não possui qualquer responsabilidade por eventuais danos materiais, morais, entre outros à vida profissional do USUÁRIO ocorrido pela visualização de seu currículo no SOFTWARE por terceiros em geral.</p>
                    <p>A SELECTY não é responsável por mídias, propagandas, produto, conteúdo oferecido no SOFTWARE por intermédio de links, cookies com publicidades. Não respondendo também por eventuais danos eventualmente suportados pelo USUÁRIO pelo acesso do currículo por terceiros. Além disso, a SELECTY não se responsabiliza pelo conteúdo ou veracidade dos anúncios de vaga divulgados no SOFTWARE. Assim sendo, qualquer negociação entre o USUÁRIO e o terceiro anunciante não serão de responsabilidade da SELECTY, comprometendo apenas o terceiro anunciante e o respectivo USUÁRIO que contratou o terceiro anunciante.</p>
                    <p>A SELECTY não será responsável por eventuais danos decorrentes do acesso ilícito por terceiros ou hackers ao SOFTWARE. A SELECTY não se responsabiliza por eventuais danos que venham a ocorrer com equipamentos do USUÁRIO ou terceiros que acessam o SOFTWARE, provocado por mau uso do SOFTWARE e de outros softwares, eventuais hardwares ou pelo uso da internet.</p>
                    <p>A SELECTY constantemente tem implementado medidas de segurança criadas para proteger as informações pessoais que o USUÁRIO compartilha, incluindo medidas físicas, eletrônicas e procedimentais. A SELECTY também monitora regularmente seus sistemas para possíveis vulnerabilidades e ataques, e regularmente procura novas maneiras e serviços de terceiros para melhorar a segurança e privacidade do USUÁRIO.</p>
                    <p>É facultado à SELECTY consultar as informações inseridas pelo USUÁRIO a fim de identificar e solucionar problemas técnicos, prestar suporte ao USUÁRIO, obedecer ordens legais e tudo o que mais necessário for para garantir que os serviços sejam prestados dentro dos preceitos éticos e legais vigentes e aplicáveis à espécie.</p>
                    <p>Independente das medidas e esforços feitos pela SELECTY, não é possível e não é garantida a proteção absoluta das informações pessoais do USUÁRIO, ou qualquer outro material que o USUÁRIO faça upload, publique ou de outra forma compartilhe com a SELECTY. Por essa razão, a SELECTY incentiva o USUÁRIO a colocar senhas fortes em sua conta e a evitar fornecer à SELECTY ou a qualquer outra pessoa qualquer informação sensível que o USUÁRIO acredite que possam causar danos consideráveis e irreparáveis caso sejam revelados.</p>
                    <p>Em casos em que terceiros não autorizados invadam o sistema de forma ilícita, a SELECTY não se responsabiliza pelos danos por eles causados.</p>
                    <h5>Cláusula quinta: CADASTRAMENTO E EDIÇÃO DO CURRÍCULO</h5>
                    <p>O cadastramento do USUÁRIO para a utilização dos serviços objeto deste contrato, se dará mediante a criação de identificação e senha exclusivas e do correto preenchimento das informações pessoais e profissionais, para a construção automática de seu currículo profissional.</p>
                    <p>O USUÁRIO se obriga a fornecer informações verdadeiras, atualizadas e completas, observando as solicitações nas páginas de registros. Dentre essas informações será solicitado seu próprio CPF/MF (CADASTRO DE PESSOAS FÍSICAS – MINISTÉRIO DA FAZENDA) ou caso não tenha, o CPF do responsável legal.</p>
                    <p>A inserção, correção, bem como a veracidade de todos os dados e informações fornecidos pelo USUÁRIO no cadastramento de seu currículo, ou em qualquer outro serviço, serão de inteira e exclusiva responsabilidade do USUÁRIO.</p>
                    <p>O USUÁRIO obriga-se a manter a sua senha em sigilo, devendo tomar todas as precauções necessárias para impedir a incorreta utilização por terceiros não autorizados, respondendo, ainda, por qualquer uso indevido da mesma. A SELECTY não se responsabiliza pelo acesso de pessoas não autorizadas com a senha do USUÁRIO.</p>
                    <p>É vedado ao USUÁRIO a criação e manutenção de mais de um cadastro no software.</p>
                    <p>O USUÁRIO, após o ato do Cadastramento, poderá, a qualquer momento, editar qualquer dado constante de seu Currículo, com exceção de seu número do CPF/MF, bastando para tanto que efetue seu LOGIN no SOFTWARE.</p>
                    <p>O USUÁRIO, tendo efetuado o LOGIN no SOFTWARE, poderá inserir dados adicionais ao seu Currículo (tais como, experiência profissional, idiomas, cursos, qualificações, telefones), escolher tornar o seu currículo profissional confidencial, modificar e atualizar toda e qualquer informação contida no seu banco de dados, disponibilizar o acesso e visualização de seu currículo para outras empresas, escolher receber e-mails ou mensagens no seu celular.</p>
                    <p>O USUÁRIO obriga-se a atualizar suas informações no sistema no prazo legal. É permitido e facultado a SELECTY deletar os registros dos USUÁRIOS que não promoverem a atualização de seus dados neste período, independente de qualquer aviso premonitório.</p>
                    <p>Todas as obrigações relacionadas ao Cadastramento aplicam-se também para a edição do currículo pelo USUÁRIO.</p>
                    <p>Fica ciente o USUÁRIO que através da chave configurações disponibilizada no SOFTWARE da SELECTY, o USUÁRIO poderá desativar o seu currículo tornando assim indisponível para acessos de busca por empresas interessadas e que utilizam o sistema SELECTY.</p>
                    <h5>Cláusula sexta: DO VALOR DOS SERVIÇOS</h5>
                    <p>Pelo cadastramento e divulgação de seu currículo o USUÁRIO não pagará, nenhum valor à SELECTY, visto que o cadastramento é totalmente gratuito. A SELECTY não se responsabiliza por eventuais pagamentos realizados pelo USUÁRIO a terceiros, pois informa desde já que não cobra nenhum valor ao USUÁRIO para utilização do SOFTWARE.</p>
                    <h5>Cláusula sétima: DA DURAÇÃO DO CONTRATO</h5>
                    <p>O presente contrato é de duração indeterminada permanecendo válido enquanto o USUÁRIO mantiver seu currículo cadastrado no SOFTWARE, devidamente atualizado.</p>
                    <p>O USUÁRIO poderá, a qualquer momento, rescindir o presente contrato, bastando, para tanto, entrar em contato através do SOFTWARE SELECTY e informar o CPF solicitando a exclusão do seu currículo no SOFTWARE, ficando ciente de que o cancelamento de seu cadastro deixará de ser divulgado.</p>
                    <h5>Cláusula oitava: FORO COMPETENTE</h5>
                    <p>Os termos dos serviços e o relacionamento entre as partes serão regidos e interpretados de acordo com as Leis da República Federativa do Brasil. O USUÁRIO e a SELECTY concordam expressamente a submeter-se à competência única e exclusiva dos tribunais brasileiros eventuais disputas ou litígios envolvendo o presente termo serão submetidos para processamento e julgamento perante o foro da comarca de Curitiba/PR, com renúncia a qualquer outro, por mais privilegiado que seja.</p>
                    <h5>Cláusula nona: DISPOSIÇÕES GERAIS</h5>
                    <p>Todas e quaisquer comunicações entre as partes deverão ser realizadas por e-mail, correspondência ou qualquer meio escrito que possa comprovar o recebimento pela outra parte.</p>
                    <p>Novamente, o USUÁRIO expressamente autoriza a SELECTY a publicar o seu currículo através de outros sítios da Internet, mediante utilização de sistemas informatizados disponibilizados por SELECTY TECNOLOGIA PARA RH LTDA, sendo-lhe aplicável neste caso todos os termos deste contrato, o qual será cedido automaticamente as outras empresas que disponibilizarem as informações.</p>
                    <p>Assim, aceitando os termos, você concorda em ficar vinculado aos seguintes termos e condições (TERMOS E CONDIÇÕES GERAIS DE UTILIZAÇÃO DO SERVIÇO) conforme supramencionado.</p>
                `
            }
        }
    },
    privacy_policy: {
        sj: {
            title: "Sobre nossa Política de Privacidade:",
            subtitle: "Como respeitamos seus dados",
            content: `
                <h5>Por que coletamos seus dados?</h5>
                <p>Trabalhamos para entregar os melhores serviços e atendimento a você, oferecendo sempre uma boa e exclusiva experiência! Por isso, precisamos coletar alguns de seus dados.</p>
                <p>Usamos esses dados para que a nossa comunicação com você seja a mais assertiva possível. Assim, é possível te atender de forma personalizada.</p>
                <p>Além disso, precisamos desses dados para cumprir nossas obrigações legais e regulatórias para que tudo esteja em conformidade com a LGPD (Lei Geral de Proteção de Dados).</p>
                <h5>Como usamos seus dados?</h5>
                <p>Nós podemos atuar de três formas: como Controladora, Co-controladora ou, ainda, como Operadora de Dados Pessoais.</p>
                <p>Mas o que isso significa? Confira a descrição de cada classificação: </p>
                <ol class="px-5">
                <li><b>CONTROLADOR:</b> Usamos os dados para formalizar contratos com clientes, recrutamento e seleção, admissão, pesquisas, qualificação de lead, ações de marketing, pesquisa e atualização de informações dos leads;</li>
                <li><b>CO-CONTROLADOR:</b> Os dados são utilizados para cadastro de colaboradores em planos de saúde e odontológicos, folha de pagamento e outros;</li>
                <li><b>OPERADOR:</b> Atividades relacionadas à plataforma SELECTY, em especial ao processamento, armazenamento, acesso e eliminação de dados pessoais.</li>
                </ol>
                <h5>Com quem compartilhamos?</h5>
                <p>Internamente, os dados que coletamos são acessados somente por profissionais autorizados, sempre pensando na segurança de seus dados e num melhor atendimento a você.</p>
                <p>Podemos compartilhar esses dados com nossos parceiros, que seguem os padrões de segurança e confidencialidade. Nós sempre avaliamos com muito cuidado nossos fornecedores e firmamos com eles obrigações contratuais de segurança da informação e proteção de dados pessoais, com o objetivo de minimizar riscos.</p>
                <p>Algumas autoridades públicas (como Autoridades Regulatórias, Receita Federal, Ministérios e outras autoridades nacionais) podem ter acesso aos dados para o cumprimento de obrigações legais ou regulatórias</p>
                <h5>Como protegemos os seus dados?</h5>
                <p>Nossas medidas para preservar os dados contra acesso, uso, alteração, divulgação ou destruição não autorizados são:</p>
                <ul class="px-5">
                <li>Proteção física e digital contra tentativas de acessos de pessoas ou programas desconhecidos;</li>
                <li>Gestão sobre quem pode acessar seus dados;</li>
                <li>Software e políticas internas de segurança.</li>
                </ul>
                <p>Todos esses controles são sempre revisados para acompanhar o contexto de ameaças na internet e contamos com equipes preparadas para detectar e responder prontamente no caso da ocorrência de algum evento ou incidente que comprometa a segurança dos seus dados ou de nossos serviços.</p>
            `
        }
    },
    footer: {
        sj: {
            fastest_way_to_hire: "O caminho mais rápido para contratar e ser contratado! ; )",
            office_location: "Office Life Ecoville",
            office_address: "Professor Pedro Viriato Parigot de Souza, 3901",
            welcome: "Estamos em Curitiba ♥ Celeiro da inovação",
            for_companies: "Para Empresas",
            post_your_jobs: "Divulgue suas vagas",
            full_recruitment_management: "Gestão completa de R&S",
            outsource_your_job: "Terceirize sua vaga",
            for_candidates: "Para Candidatos",
            search_jobs: "Buscar Vagas",
            create_profile: "Criar perfil",
            privacy_policy: "Política de Privacidade",
            faq: "FAQ",
            follow_us: "Nos siga nas redes sociais!",
            copyright: "Copyright © {year} | Selecty.Jobs © Todos os direitos reservados",
            company: "Selecty Tecnologia para RH | CNPJ: 09.236.362/0001-50"
        },
        customer: {
            privacy_policy: "Política de Privacidade",
            cookie_policy: "Política de Cookies",
        },
    },
    domains: {
        logo_position: {
            normal: "Normal",
            centralized: "Centralizado",
            top_square: "Superior Quadrada"
        },
        gender: {
            male_abb: "Masc",
            female_abb: "Fem",
            do_not_inform: "Não informar",
        },
        nationalities: {
            brazilian_native: "Brasileiro nato",
            naturalized: "Naturalizado",
            foreigner: "Estrangeiro"
        },
        data_holder: {
            I_am_data_holder: "Sou o titular dos dados",
            I_am_attorney_or_representative: "Sou procurador ou representante"
        },
        data_holder_category: {
            client: "Cliente",
            collaborator: "Colaborador",
            lead_prospect: "Lead/Prospect",
            former_collaborator: "Ex-colaborador",
            supplier: "Fornecedor"
        },
        exercise_rights: {
            correct_data_incomplete_inaccurate_outdated: "Corrigir dados incompletos, inexatos ou desatualizados",
            allow_data_portability: "Permitir a portabilidade dos dados a outro fornecedor de serviço ou produto",
            receive_information_shared_entities: "Receber informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados",
            revoke_consent: "Revogar consentimento",
            review_automated_decisions: "Revisão de decisões tomadas unicamente com base em tratamento automatizado de dados pessoais",
            confirm_data_processing_and_access: "Somente confirmar a existência de tratamento e ter acesso aos meus dados que são tratados pela Selecty"
        },
        result_request: {
            electronic_contact_email: "Meio eletrônico (e-mail): o e-mail de contato será o mesmo preenchido para o titular dos dados pessoais ou procurador, quando aplicável",
            printed_format_address: "Formato impresso: o endereço utilizado será o mesmo preenchido para o titular de dados pessoais ou procurador, quando aplicável"
        },
        armed_forces_service_status: {
            armed_forces_enlisted: "Alistado",
            armed_forces_reservist: "Reservista",
            armed_forces_exempt: "Dispensado"
        },
        bank_types: {
            bank_type_current_account: "Conta Corrente",
            bank_type_savings_account: "Conta Poupança",
            bank_type_salary_account: "Conta Salário"
        },
        bank_holder_types: {
            bank_holder_individual: "Pessoa Física",
            bank_holder_legal_entity: "Pessoa Jurídica"
        },
        bank_pix_types: {
            pix_type_not_informed: "Não Informado",
            pix_type_phone: "Telefone",
            pix_type_email: "Email",
            pix_type_cpf_cnpj: "CPF/CNPJ",
            pix_type_random_key: "Chave Aleatória"
        },
        tshirt: {
            tshirt_size_small: "P",
            tshirt_size_medium: "M",
            tshirt_size_large: "G",
            tshirt_size_extra_large: "GG",
            tshirt_size_extra_extra_large: "EG"
        },
        suit: {
            suit_size_small: "P",
            suit_size_medium: "M",
            suit_size_large: "G",
            suit_size_extra_large: "GG",
            suit_size_extra_extra_large: "XG",
            suit_size_extreme_large: "XXG"
        },
        holster: {
            holster_right: "Direita",
            holster_left: "Esquerda"
        },
        benefits: {
            benefit_meal_voucher: "Vale Refeição",
            benefit_food_voucher: "Vale Alimentação",
            benefit_medical_assistance: "Assistência Médica <small>(verifique se sua empresa é elegível para este benefício)</small>",
            benefit_transport_voucher: "Vale Transporte",
            benefit_no_voucher: "Nenhum beneficio",
        },
        way_transports: {
            go : "Ida",
            back : "Volta",
        },
        transports: {
            bus: "Ônibus",
            subway: "Metrô",
            train: "Trem",
            van: "Van",
            integration: "Integração",
        },
        vacancies: {
            vacancy_removed_from_favorites_success: "Vaga removida da sua lista de favoritos com sucesso",
        },
        account: {
            registration_found: 'Localizamos seu cadastro!',
            registration_found_provide_password: "Localizamos seu cadastro, por favor informe sua senha!",
            user_not_registered_employee_portal_exclusive: "Não encontramos seu cadastro como colaborador. Este portal é exclusivo para colaboradores!",
        },
        civil_status: {
            not_informed: "Não informado",
            single: 'Solteiro',
            married: 'Casado',
            separated: "Separado",
            divorced: "Divorciado",
            widowed: "Viúvo",
            civil_union: "União Estável",
        },
        document_type: {
            national_registry_of_foreigners: "Registro Nacional de Estrangeiros",
            passport: "Passaporte",
            national_migration_registry: "Registro Nacional Migratório",
        },
        company_sizes: {
            large_company: "Empresa de grande porte",
            medium_company: "Empresa de médio porte",
            small_company: "Empresa de pequeno porte",
            micro_company: "Micro-empresa",
            self_employed_activity: "Atividade autônoma",
        },
        acting_areas: {
            agriculture_livestock: "Agricultura e Pecuária",
            food: "Alimentos",
            architecture: "Arquitetura",
            arts: "Artes",
            medical_assistance: "Assistência Médica",
            associations: "Associações",
            audit: "Auditoria",
            automotive: "Automotivo",
            auto_parts: "Autopeças",
            aviation: "Aviação",
            banks: "Bancos",
            beverages: "Bebidas",
            biological_sciences: "Ciências Biológicas",
            gifts: "Brindes",
            toys: "Brinquedos",
            footwear_leather: "Calçados e Couro",
            bedding_bath: "Cama, Mesa e Banho",
            wholesale_trade: "Comércio Atacadista",
            foreign_trade: "Comércio Exterior",
            retail_trade: "Comércio Varejista",
            visual_communication_design: "Comunicação Visual e Design",
            civil_construction: "Construção Civil",
            consulting: "Consultoria",
            accounting: "Contabilidade",
            brokerage: "Corretoras",
            dealership: "Concessionária",
            distributors: "Distribuidores",
            education: "Educação",
            appliances: "Eletrodomésticos",
            packaging: "Embalagens",
            energy: "Energia",
            engineering: "Engenharia",
            teaching_research: "Ensino e Pesquisa",
            entertainment_culture_leisure: "Entretenimento, Cultura e Lazer",
            sports: "Esporte",
            beauty_aesthetics: "Estética e Beleza",
            pharmaceutical: "Farmacêutico",
            tools: "Ferramentas",
            finance: "Finanças",
            franchises: "Franquias",
            tobacco: "Fumo",
            government: "Governo",
            printing: "Gráfica",
            hygiene_cleaning: "Higiene e Limpeza",
            hospitality: "Hoteleiro",
            real_estate: "Imobiliário",
            press_communication: "Imprensa e Comunicação",
            industry: "Indústria",
            internet: "Internet",
            legal: "Jurídico",
            wood: "Madeira",
            machinery_equipment: "Máquinas e Equipamentos",
            construction_material: "Material de Construção",
            office_supplies: "Material de Escritório",
            electronic_material: "Material Eletrônico (Componentes Eletrônicos)",
            mechanics: "Mecânica",
            environment: "Meio Ambiente",
            metallurgy: "Metalúrgico",
            mining: "Mineração",
            furniture_decor: "Móveis e Decoração",
            non_metals: "Não Metálicos",
            paper_pulp: "Papel e Celulose",
            perfumery_cosmetics: "Perfumaria e Cosméticos",
            petrochemical: "Petroquímica",
            plastic_rubber: "Plástico e Borracha",
            advertising: "Publicidade",
            chemistry: "Química",
            human_resources: "Recursos Humanos",
            religion: "Religião",
            health_hospital_lab: "Saúde, Hospitalar e Laboratorial",
            insurance_private_pension: "Seguradoras e Previdência Privada",
            private_security: "Segurança Privada",
            other_services: "Serviços (outros)",
            public_services: "Serviços Públicos",
            technology_it: "Tecnologia e Informática",
            telecommunications: "Telecomunicações",
            telemarketing: "Telemarketing / Call Center",
            third_sector_ngo: "Terceiro Setor / ONG",
            textile: "Têxtil",
            domestic_work: "Trabalho Doméstico",
            air_transport: "Transporte Aéreo",
            transport_logistics: "Transporte e Logística",
            tourism: "Turismo",
            housewares: "Utilidades Domésticas",
            clothing: "Vestuário",
            veterinary: "Veterinária",
        },
        admissional_education_level: {
            illiterate: "Analfabeto",
            up_to_5th_grade_elementary: "Até o 5º Ano do Ensino Fundamental",
            completed_5th_grade_elementary: "5º ano completo do Ensino Fundamental",
            from_6th_to_9th_grade_elementary: "Do 6º ao 9º do Ensino Fundamental",
            completed_elementary: "Ensino Fundamental Completo",
            incomplete_high_school: "Ensino Médio incompleto",
            completed_high_school: "Ensino Médio completo",
            incomplete_higher_education: "Educação superior incompleto",
            completed_higher_education: "Educação superior completo",
            incomplete_postgraduate: "Pós-Graduação incompleto",
            completed_postgraduate: "Pós-Graduação completo",
            incomplete_master: "Mestrado incompleto",
            completed_master: "Mestrado completo",
            incomplete_doctorate: "Doutorado incompleto",
            completed_doctorate: "Doutorado completo",
            incomplete_postdoctorate: "Pós-Doutorado incompleto"
        },
        cnh_type: {
            a: "A",
            b: "B",
            c: "C",
            d: "D",
            e: "E",
            ab: "AB",
            ac: "AC",
            ad: "AD",
            ae: "AE",
            no_license: "Não possuo CNH"
        },
        street_type: {
            airport: "Aeroporto",
            alley: "Alameda",
            area: "Área",
            avenue: "Avenida",
            field: "Campo",
            farm: "Chácara",
            colony: "Colônia",
            condominium: "Condomínio",
            complex: "Conjunto",
            district: "Distrito",
            esplanade: "Esplanada",
            station: "Estação",
            road: "Estrada",
            shantytown: "Favela",
            market: "Feira",
            garden: "Jardim",
            hill: "Ladeira",
            lake: "Lago",
            lagoon: "Lagoa",
            square: "Largo",
            allotment: "Loteamento",
            hillock: "Morro",
            core: "Núcleo",
            park: "Parque",
            catwalk: "Passarela",
            courtyard: "Pátio",
            plaza: "Praça",
            block: "Quadra",
            retreat: "Recanto",
            residential: "Residencial",
            highway: "Rodovia",
            street: "Rua",
            sector: "Setor",
            ranch: "Sítio",
            lane: "Travessa",
            section: "Trecho",
            cloverleaf: "Trevo",
            valley: "Vale",
            path: "Vereda",
            way: "Via",
            viaduct: "Viaduto",
            alleyway: "Viela",
            village: "Vila"
        },
        race: {
            no_information: "Não desejo informar",
            white: "Branca",
            black: "Preta",
            brown: "Parda",
            yellow: "Amarela",
            indigenous: "Indígena"
        },
        gender_identity: {
            cis_woman: "Mulher Cis",
            trans_woman: "Mulher Trans",
            cis_man: "Homem Cis",
            trans_man: "Homem Trans",
            non_binary: "Não-binário",
            other: "Outro",
            prefer_not_to_answer: "Prefiro não responder"
        },
        gender_orientation: {
            asexual: "Assexual",
            bisexual: "Bissexual",
            heterosexual: "Heterossexual",
            homosexual: "Homossexual",
            pansexual: "Pansexual",
            other: "Outro",
            prefer_not_to_answer: "Prefiro não responder"
        }
    },
};
